import React, { useEffect, useRef, useState } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import "./groupClaim.css"
import { Modal, NumberInput, Radio, Select, TextInput, Tooltip } from "@mantine/core";
import { ReactComponent as SelectIcon } from "../../assets/fi-rr-angle-small-down.svg";
import { ReactComponent as UploadIcon } from "../../assets/humbleicons_upload.svg";
import AsyncSelect from "react-select/async";
import axios from "axios";
import base_url from "../../api/bootapi";
import CustomDOBPicker from "../../components/CustomDOBPicker";
import moment from "moment";
import CustomButton from "../../components/CustomButton";
import { RemoveCircleOutline } from "@mui/icons-material";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { IconPlaneArrival, IconPlaneDeparture } from "@tabler/icons-react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { CountryDropdown } from "react-country-region-selector";
import { ReactComponent as VectorIcon } from "../../assets/Vector.svg";
import TravelerForm from "./TravelerForm";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import AgreementModal from "../fileClaim/AgreementModal";
import DocuSignModal from "../fileClaim/DocuSignModal";
import PowerContent from "../fileClaim/PowerContent";

import { ReactComponent as SuccessIcon } from "../../assets/success-eligibility.svg";
import { ReactComponent as FailedIcon } from "../../assets/failed-eligibility.svg";
import { ReactComponent as HeadSetIcon } from "../../assets/fi-rr-headset.svg";
import { ReactComponent as DocumentIcon } from "../../assets/fi-rr-document.svg";

const emptyRow = {
  first_name: "",
  last_name: "",
  dob: "",
  nationality: "",
  passport_number: "",
  ticket: "",
  airline_res_no: "",
};
export default function GroupClaim() {
  const [travelers, setTravelers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setValue('groupDetails.passengers',travelers.length+1)
  },[travelers])

  


   const [isAgreementChecked, setIsAgreementChecked] = useState(false);
    const [isPowerOfAttorneyChecked, setIsPowerOfAttorneyChecked] =
    useState(false);
  
    const [isAgreementModalOpen, setAgreementModalOpen] = useState(false);
  
  
    const [showContinueBtn, setShowContinueBtn] = useState(false)
  const [isAgreementLinkClicked, setIsAgreementLinkClicked] = useState(false);
    const [isPowerLinkClicked, setIsPowerLinkClicked] = useState(false);
    const [envolpeId, setEnvelopeId] = useState();
  const [agreementUrl, setAgreementUrl] = useState(null);
   const [pdfBlob, setPdfBlob] = useState(null);
  const [signatureCaptured, setSignatureCaptured] = useState(false);
  
  const closeAgreementModal = () => setAgreementModalOpen(false);

    const handleSignatureAdded = (signatureData) => {
    ////console.log("ok");
  };
   const [activeTab, setActiveTab] = useState(
      localStorage.getItem("activeClaimTab") ||
      "flight delay / flight cancellation"
    );

    const [signUrl, setSignUrl] = useState(null);
    const [documentFetched, setDocumentFetched] = useState(false);
  
    const [isDocuSignModalOpen, setIsDocusignModalOpen] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
  
    const handlePdfGenerated = (blob) => {
    setPdfBlob(blob);
    setSignatureCaptured(true); // Set state to show "View Agreement" button
  };
    const [dataToStore, setDataToStore] = useState(null);
  
    const handleCheckAgreement = () => {
     
      const todayDate = moment().format("DD-MM-YYYY");
  
     
      const storeData = {
        date: todayDate,
        clientName: `${getValues('personalInfo.first_name')} ${getValues('personalInfo.last_name')}`,
        clientAddress: getValues('personalInfo.address'),
        passportNumber:getValues('personalInfo.passport_number'),
        clientEmail: getValues('personalInfo.email_id'),
        bookingNumber: getValues('personalInfo.contact_no'),
        clientBirthDate: getValues('personalInfo.date_of_birth'),
        familyMembers: travelers, 
        flightDetails: getValues('originalFlights'),
        clientTicketNumber:getValues('personalInfo.ticket_number'),
      };
  
      setDataToStore(storeData);
  
      console.log("Data to store", storeData);
  
      return true;
    };
  
    const handleCheckPowerOfAttorney = () => {
      return handleCheckAgreement();
  };
  

    const handleAgreementChange = (event) => {
      //console.log("574---------->", event.target.checked);
  
      if (isAgreementLinkClicked) {
        setIsAgreementChecked(event.target.checked);
        //console.log("578---------->", event.target.checked);
      } else {
        event.preventDefault();
        Swal.fire({
          title: "Please read the Agreement",
          text: "You must click on the Agreement link and read them before checking the checkbox.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    };
  
    const handlePowerOfAttorneyChange = (event) => {
      if (isPowerLinkClicked) {
        setIsPowerOfAttorneyChecked(event.target.checked);
      } else {
        event.preventDefault();
        Swal.fire({
          title: "Please read the Power of Attorney",
          text: "You must click on the Power of Attorney link and read it before proceeding.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    };


   const handleIframeClose = () => {
    fetchSignedDocument();
  };


   const fetchSignedDocument = async () => {
      try {
        setBackdropOpen(true);
        // const sign_url = `${base_url.api1}/tourapp/get_signed_doc?id=${envolpeId}`;
        const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${envolpeId}`;
  
        const response = await axios.get(sign_url);
  
        console.log(response)
        if (response?.data && response?.data?.status_code === 200) {
          setIsAgreementLinkClicked(true);
        }
        if (response.data && response.data.Document) {
          const document_url = response.data.Document;
  
          const pdfResponse = await fetch(document_url);
  
          if (!pdfResponse.ok) {
            throw new Error("Failed to fetch the document.");
          }
  
          const pdfBlob = await pdfResponse.blob();
  
          setPdfBlob(pdfBlob);
          setSignatureCaptured(true);
          setDocumentFetched(true);
  
        } else {
          console.error("Signed document is not present in the response.");
  
  
        }
      } catch (error) {
        console.error("Error fetching signed document:", error);
  
  
      } finally {
        //console.log("Completed fetching the document.");
        setBackdropOpen(false);
  
  
      }
  };
  
   const openPowerOfAttorneyModal = () => {
      Swal.fire({
        title: "Important: Power of Attorney",
        html: `
        Please print and have all signatures completed. Email back document to <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com</a>  or access your claim from our website to sign the documents electronically.
        
        `,
        icon: "warning",
        confirmButtonText: "OK",
      }).then(() => {
        // Code to execute after the user clicks "OK"
        setIsPowerLinkClicked(true);
        // setIsPowerModalOpen(true);
        getPowerOfAttorney();
      });
  };
  

    const [signers, setSigners] = useState([]);
    const [isPowerOfAttorneyFetchedErrorModal, setIsPowerOfAttorneyFetchedErrorModal] = useState(false);
  
    const [powerPdf, setPowerPdf] = useState(null);
    const [poaPdf, setPoaPdf] = useState(null);
  
  const powerRef = useRef(null);

   const getPowerOfAttorney = async () => {
      setIsPowerOfAttorneyFetchedErrorModal(false);
      const content = powerRef.current;
      let htmlString = null;
  
      if (content) {
        htmlString = content.innerHTML;
      }
      setBackdropOpen(true);
  
      const signers = travelers.map((claim, index) => ({
        name: `${claim.first_name.toUpperCase()} ${claim.last_name.toUpperCase()}`,
        email_id: `flyandclaim${index}@gmail.com`,
      }));
  
  
      const controller = new AbortController();
      const TIMEOUT_MS = 30000; // 15 seconds
  
      // auto-abort after TIMEOUT_MS
      const timeoutId = setTimeout(() => {
        controller.abort();
        setIsPowerOfAttorneyFetchedErrorModal(true);
        setBackdropOpen(false);
      }, TIMEOUT_MS);
  
      try {
        const response = await axios.post(
          `${base_url.api1}/tourapp/power_of_attorney_latest`,
          {
            html_string: htmlString,
            signers: signers,
          }
        );
  
        clearTimeout(timeoutId);
  
        if (response.data && response.data.status && response.data.document) {
          setSigners(response.data.signers || []);
          //console.log("Power of Attorney PDF fetched successfully.");
          const base64PDF = response.data.document;
          handlePowerPDF(base64PDF);
          setBackdropOpen(false);
        } else {
  
  
          console.error("Failed to fetch Power of Attorney PDF.");
          setBackdropOpen(false);
          setIsPowerOfAttorneyFetchedErrorModal(true);
        }
      } catch (error) {
  
        clearTimeout(timeoutId);
        // Detect abort/timeout
        const isAbort =
          error?.code === "ERR_CANCELED" || // axios recent cancellation code
          error?.name === "CanceledError" || // some axios builds
          error?.message?.toLowerCase().includes("aborted") ||
          error?.message?.toLowerCase().includes("canceled");
  
        if (isAbort) {
          console.warn("Request aborted due to timeout (>= 15s).");
        } else {
          console.error("Error fetching Power of Attorney PDF:", error);
        }
        setBackdropOpen(false);
        setIsPowerOfAttorneyFetchedErrorModal(true);
      } finally {
        clearTimeout(timeoutId);
  
        setBackdropOpen(false);
  
      }
  
  
  
  
  
  
  
  
  
  
  
  };


   const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };
  

   const handlePowerPDF = (base64PDF) => {
    const pdfBlob = base64ToBlob(base64PDF, "application/pdf");

    setPowerPdf(pdfBlob);
    setPoaPdf(pdfBlob);

   
  };




























  const flightClassOptions = [
    { value: "First", label: "First" },
    { value: "Business", label: "Business" },
    { value: "Premium", label: "Premium" },
    { value: "Economy", label: "Economy" },
  ];

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
    trigger,
    getValues
  } = useForm({
    defaultValues: {
      groupDetails: {
        group_name: "",
        type_of_claim: "",
        passengers: 1,
      },

      personalInfo: {
        
      },
      

      originalFlights: [{
        airline: "",
        flight_number: "",
        airport_of_origin: "",
        airport_of_destination: "",
        date_of_travel: "",
        original_departure_time: "",
        original_arrival_time: "",
        original_departure_date: "",
        original_arrival_date: "",
        original_departure: "",
        original_arrival: "",
        hub_code: "",
        iata_code: "",
        search_by: "airline_name",
        flight_class: "Economy",

        // New fields for the enhanced form logic
        ticket_ref_no: "",
        disruption: "", // delayed, cancelled, missed
        delay_duration: "", // Less than 3 hours, 3–4 hours, 4+ hours
        flight_cancel: "", // Before arriving at the airport, At the airport
        missed_connection: "", // Flight delay, Airline error, Personal reasons
        // claim_details: "", // Any additional information provided by the user

        additional_details: "",

        delayed: false,
        cancelled: false,
        missed: false,
        denied: false,
        downgraded: false,
        cancellation_info_before: false,
        cancellation_info_at_airport: false,
        missed_due_to_error: false,
        missed_due_to_personal: false,
      }],

      actualFlights: [
        {
           actual_airline: "",
        actual_flight_number: "",
        actual_airport_of_origin: "",
        actual_airport_of_destination: "",
        actual_date_of_travel: "",
        actual_departure_time: "",
        actual_arrival_time: "",
        actual_departure_date: "",
        actual_arrival_date: "",

        actual_flight_class: "Economy",

        actual_departure: "",
        actual_arrival: "",
        actual_hub_code: "",
        ticket_ref_no: "",
        provided_by_airline: false,
        self_booked: false,
        same_as_original: false,
        search_by: "airline_name",
        },
      ],

   
      termsAccepted: false,

    isTermsLinkClicked: false, // ✅ MUST ADD

      documents: {
        boardingPass: null,
        passport: null,
        additionalDocs: null,
      },
    },
  });


  const isFormValid = async() => {
     const isValid = await trigger(); // ✅ validate entire form

    if (!isValid) {
    

      Swal.fire({
        title: "Complete Required Fields",
        text: "Please fill all required fields before reading Terms & Conditions.",
        icon: "warning",
        confirmButtonText: "OK",
      });

      return false;
    }

    return true

  }

  // ✅ Field Arrays
  const {
    fields: originalFlights,
    append: addOriginalFlights,
    remove: removeOriginalFlights,
  } = useFieldArray({
    control,
    name: "originalFlights",
  });

  const {
    fields: actualFlights,
    append: addActualFlights,
    remove: removeActualFlights,
  } = useFieldArray({
    control,
    name: "actualFlights",
  });


const handleCheckTerm = () => {
  const clicked = getValues("isTermsLinkClicked"); // ✅ better than watch

  if (clicked) {
    return true;
  }

  Swal.fire({
    title: "Please read the Terms and Conditions",
    text: "You must click on the Terms and Conditions link before checking.",
    icon: "warning",
    confirmButtonText: "OK",
  });

  return false; // ✅ IMPORTANT
};
 

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "52px",
      borderRadius: "30px", // 🔥 pill shape
      backgroundColor: "#e8eef7", // light grey
      border: "none",
      boxShadow: "none",
      padding: "0 10px",

      "&:hover": {
        border: "none",
      },
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 12px",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#9CA3AF", // soft grey text
      fontSize: "16px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#374151",
      fontSize: "16px",
    }),

    indicatorSeparator: () => ({
      display: "none", // remove line
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#6B7280",
      paddingRight: "12px",
    }),

    menu: (base) => ({
      ...base,
      // borderRadius: "12px",
      overflow: "hidden",
      marginTop: "6px",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#F3F4F6" : "white",
      color: "#111827",
      padding: "10px 14px",
      cursor: "pointer",
    }),
  };

  const manualAddress = watch("personalInfo.manual_address");
  const [defaultAirlineOptions, setDefaultAirlineOptions] = useState([]);
  const [defaultAirportOptions, setDefaultAirportOptions] = useState([]);


    const parseAddressComponents = (components = []) => {
    const result = { city: "", state: "", postalCode: "", country: "" };

    components.forEach((c) => {
      if (c.types.includes("locality")) {
        result.city = c.long_name;
      }
      if (!result.city && c.types.includes("sublocality_level_1")) {
        result.city = c.long_name;
      }
      if (!result.city && c.types.includes("administrative_area_level_2")) {
        result.city = c.long_name;
      }

      if (c.types.includes("administrative_area_level_1")) {
        result.state = c.long_name;
      }
      if (c.types.includes("postal_code")) {
        result.postalCode = c.long_name;
      }
      if (c.types.includes("country")) {
        result.country = c.long_name;
      }
    });

    return result;
  };

  // Helper: build only street-level address (exclude locality/admin/postal/country)
  const buildStreetAddress = (components = [], placeName = "") => {
    const keepTypes = new Set([
      "street_number",
      "route",
      "subpremise",
      "premise",
      "sublocality_level_1",
      "sublocality",
      "neighborhood",
      "establishment",
      "natural_feature",
      "airport",
    ]);

    const excludeTypes = new Set([
      "locality",
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "postal_code",
      "country",
    ]);

    // First strict pass: keep components that contain at least one keepTypes and do not contain any exclude types
    const streetParts = components
      .filter((c) => {
        if (c.types.some((t) => excludeTypes.has(t))) return false;
        return c.types.some((t) => keepTypes.has(t));
      })
      .map((c) => c.long_name);

    // If we have streetParts, attempt to join in a sensible order: street_number before route
    if (streetParts.length) {
      // Try to put street number before route
      const number = components.find((c) => c.types.includes("street_number"))?.long_name;
      const route = components.find((c) => c.types.includes("route"))?.long_name;
      if (number && route) return `${number} ${route}`;
      // otherwise return the joined streetParts (first 3 parts)
      return streetParts.slice(0, 3).join(", ");
    }

    // Loose fallback: exclude obvious admin/postal/country types and take first few parts
    const loose = components
      .filter((c) => !c.types.some((t) => excludeTypes.has(t)))
      .map((c) => c.long_name);

    if (loose.length) return loose.slice(0, 3).join(", ");

    // Use place's name (business or establishment) as last-resort
    if (placeName) return placeName;

    return "";
  };

   const onPlaceSelect_JS = (val) => {


    if (!val) {
      // clear related fields
      setValue("personalInfo.city", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      setValue("personalInfo.state", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      setValue("personalInfo.postal_code", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });

      return;
    }

    // val.value might be a placeId or an object containing place_id
    let placeId = typeof val.value === "string" ? val.value : (val.value?.place_id || val.value?.placeId);
    if (!placeId && val?.place_id) placeId = val.place_id;

    const addressLabel = val.label || val.description || "";

    // Save a temporary address label while we fetch details
    // setValue('address', addressLabel, { shouldValidate: true, shouldDirty: true, shouldTouch: true });

    if (!window.google || !placeId) {
      // Google script not loaded (or not available) — keep the label but we can't refine components
      console.warn("Google script not loaded or missing placeId — cannot get address components.");
      return;
    }

    const ps = new window.google.maps.places.PlacesService(document.createElement("div"));

    ps.getDetails({ placeId, fields: ["address_components", "formatted_address", "name"] }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
        const parsed = parseAddressComponents(place.address_components || []);

        // keep other fields if you still want them stored in the form
        setValue("personalInfo.city", parsed?.city || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("personalInfo.state", parsed?.state || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("personalInfo.postal_code", parsed?.postalCode || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("personalInfo.country", parsed?.country || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        
        

        // Build street-only address
        let streetAddress = buildStreetAddress(place.address_components || [], place.name || "");

        // If still empty, fallback to taking the first part(s) of formatted_address
        if (!streetAddress) {
          if (place.formatted_address) {
            // Take first segment(s) before locality/admin; naive split by comma
            const parts = place.formatted_address.split(",").map((p) => p.trim()).filter(Boolean);
            // prefer the first part (street line) only
            if (parts.length) streetAddress = parts[0];
          }
        }

        // Final fallback: use the label from autocomplete
        if (!streetAddress) streetAddress = addressLabel;

        setValue('personalInfo.address', streetAddress || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      } else {
        console.error("getDetails failed:", status);
      }
    });
  };

  const getNewDelayDuration = (formatHHMM = false) => {
    const flightDetails = getValues('originalFlights');
    const actualFlightDetails = getValues('actualFlights');
    let delay = 0
    try {
      if (getValues('groupDetails.type_of_claim') !== 'cancelled') {


        const orignalArrivalDate = formatToYYYYMMDD(flightDetails.at(-1).original_arrival_date) + "T" + flightDetails.at(-1).original_arrival_time
        const actualArrivalDate = formatToYYYYMMDD(actualFlightDetails.at(-1).actual_arrival_date) + "T" + actualFlightDetails.at(-1).actual_arrival_time


        console.log(flightDetails, actualFlightDetails)
        console.log(orignalArrivalDate, actualArrivalDate)

        delay = getDelayDuration(orignalArrivalDate, actualArrivalDate);





      } else {
        const orignalArrivalDate = formatToYYYYMMDD(flightDetails.at(-1).original_arrival_date) + "T" + flightDetails.at(-1).original_arrival_time
        const actualArrivalDate = formatToYYYYMMDD(flightDetails.at(-1).actual_arrival_date) + "T" + flightDetails.at(-1).actual_arrival_time

        console.log(flightDetails, actualFlightDetails)
        console.log(orignalArrivalDate, actualArrivalDate)

        delay = getDelayDuration(orignalArrivalDate, actualArrivalDate);




      }
    } catch (e) {
      console.log(e)
      return formatHHMM ? null : 0
    }


    console.log(delay)
    return formatHHMM ? formatDurationHHMM(delay) : delay
  }

    function formatDurationHHMM(minutes) {
    if (minutes === null || minutes === undefined || isNaN(minutes)) {
      return null;
    }
    console.log(minutes)
    const sign = minutes < 0 ? "-" : "";
    const absMinutes = Math.abs(minutes);
    const hours = Math.floor(absMinutes / 60);
    const mins = absMinutes % 60;
    console.log(`${sign}${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`)
    return `${sign}${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  }

  const dateFormat = (dateString) => {
    if (!dateString || dateString === "+00:00") return "";

    try {

      const dateStr = dateString.slice(0, 16);

      const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

      if (!regex.test(dateStr)) return "";

      const date = moment(dateStr).format("MM-DD-YYYY");
      const time = moment(dateStr).format("HH:mm");

      console.log(date, time)


      return { date, time };
    } catch (err) {
      console.error("Invalid date or timezone", err);
      return { date: "", time: "" };
    }
  };

  const formatToYYYYMMDD = (dateOfBirth) => {


    return moment(dateOfBirth, "MM-DD-YYYY").format("YYYY-MM-DD");
  };
  const [backdropOpen, setBackdropOpen] = useState(false)
    const isMobile = useMediaQuery("(max-width: 768px)");
  
   const [multiFlightOpened, { open: multiFlightOpen, close: multiFlightClose }] = useDisclosure(false);
  const [successModalOpened, { open: successModalOpen, close: successModalClose }] = useDisclosure(false);
  const [isSuccessResponse,setSuccessResponse]=useState(false)
   const [travelersModalOpened, { open: travelersModalOpen, close: travelersModalClose }] = useDisclosure(false);
     const [multiFlightData, setMultiFlightData] = useState([]);
     const [filteredFlightData, setFilteredFlightData] = useState(null);
     const [flightIndex, setFlightIndex] = useState(null);
  const [flightType, setFlightType] = useState(null);




  



    function getFlightStatus(code) {
    switch (code) {
      case "A":
        return "Active (in flight)";
      case "C":
        return "Canceled";
      case "D":
        return "Diverted";
      case "DN":
        return "Data Needed / Not Available";
      case "L":
        return "Landed";
      case "NO":
        return "Not Operational";
      case "R":
        return "Redirected";
      case "S":
        return "Scheduled";
      case "U":
        return "Unknown";
      default:
        return code;
    }
  }

  const fmt = (dt) => {
    if (!dt) return "N/A"; // null, undefined, empty, 0

    const date = new Date(dt);
    if (isNaN(date.getTime())) return "N/A"; // invalid date

    return date.toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  
  const [selectedFlightIndex, setSelectedFlightIndex] = useState(null);
  
    const handleSelectFlight = (index) => {
      setSelectedFlightIndex(index);
      setMultiFlightData(prev =>
        prev.map((f, i) => ({
          ...f,
          selected: i === index  // only one true
        }))
      );
    };


  
  const handleSaveFlightDetails = (index) => {
    const flightList = filteredFlightData[selectedFlightIndex];
    const from = flightType;
  if (!flightList) return;

  const isActual = from === "actualFlights";
  const prefix = `${from}.${index}`;

  const departure = flightList.departure;
  const arrival = flightList.arrival;

    
     const departureActual = departure?.actual || departure?.actual_runway || departure?.estimated || departure?.estimated_runway || departure?.scheduled;
    const arrivalActual = arrival?.actual || arrival?.actual_runway || arrival?.estimated || arrival?.estimated_runway || arrival?.scheduled
    const departureScheduled = departure?.scheduled;
        const arrivalScheduled = arrival.scheduled;



  // ✅ COMMON FIELDS
  
  setValue(`${prefix}.departure_iata_code`, departure.iata || "");
  setValue(`${prefix}.arrival_iata_code`, arrival.iata || "");
  setValue(`${prefix}.delay_duration_minutes`, flightList.delay_duration_minutes || 0);

  if (isActual) {
    // ✅ ACTUAL

  
     setValue(`${prefix}.actual_airport_of_origin`, departure.airport || "");
    setValue(`${prefix}.actual_airport_of_destination`, arrival.airport || "");
     
      setValue(`${prefix}.actual_departure_time`,  dateFormat(departureActual, departure.timeZone).time);
    setValue(`${prefix}.actual_departure_date`, dateFormat(departureActual, departure.timeZone).date);

    setValue(`${prefix}.actual_arrival_time`, dateFormat(arrival.arrivalActual, arrival.timeZone).time);
    setValue(`${prefix}.actual_arrival_date`, dateFormat(arrival.arrivalActual, arrival.timeZone).date);
 
  
  } else {
    // ✅ ORIGINAL

      setValue(`${prefix}.airport_of_origin`, departure.airport || "");
      setValue(`${prefix}.airport_of_destination`, arrival.airport || "");
      
      setValue(`${prefix}.original_departure_time`,dateFormat(departureScheduled, departure.timeZone).time);
    setValue(`${prefix}.original_departure_date`, dateFormat(departureScheduled, departure.timeZone).date);

    setValue(`${prefix}.original_arrival_time`, dateFormat(arrivalScheduled, arrival.timeZone).time);
    setValue(`${prefix}.original_arrival_date`,  dateFormat(arrivalScheduled, arrival.timeZone).date);

    // optionally also set actual (if API gives it)
  
      setValue(`${prefix}.actual_departure_time`,  dateFormat(departureActual, departure.timeZone).time);
      setValue(`${prefix}.actual_departure_date`,  dateFormat(departureActual, departure.timeZone).date);
    
      setValue(`${prefix}.actual_arrival_time`, dateFormat(arrivalActual, arrival.timeZone).time);
      setValue(`${prefix}.actual_arrival_date`, dateFormat(arrivalActual, arrival.timeZone).date);
  
  }

  // ✅ CLOSE MODAL (UI only)
  multiFlightClose();
  setBackdropOpen(false);
};

  
   const getDelayDuration = (scheduled, actual) => {
      if (
        scheduled &&
        scheduled !== null &&
        scheduled !== undefined &&
        scheduled !== "" &&
        scheduled !== "+00:00" && scheduled !== "" &&
        actual &&
        actual !== null &&
        actual !== undefined &&
        actual !== "" &&
        actual !== "+00:00" &&
        actual !== ""
      ) {
        try {
  
  
  
  
          const ms = moment.utc(actual.slice(0, 16)).diff(moment.utc(scheduled.slice(0, 16)));
          const mins = Math.floor(moment.duration(ms).asMinutes());
          return mins;
  
        } catch (error) {
          console.error("Error calculating delay duration:", error);
          return 0;
        }
      }
      return 0;
    };
  const fetchFlightOptions = async (index, from = "originalFlights") => {
  const flight = watch(`${from}.${index}`);

  const isActual = from === "actualFlights";

  const date = isActual
    ? flight?.actual_date_of_travel
    : flight?.date_of_travel;

  const hubCode = isActual
    ? flight?.actual_hub_code
    : flight?.hub_code;

  const flightNumber = isActual
    ? flight?.actual_flight_number
    : flight?.flight_number;

  if (!date || !hubCode || !flightNumber) {
    alert("Fill required fields first");
    return;
  }
    setBackdropOpen(true)
   

  try {
    const res = await axios.post(`${base_url.api1}/tourapp/flight_states`, {
      airline_code: hubCode,
      flight_number: flightNumber,
      flight_date: formatToYYYYMMDD(date),
    });

    const flights = res?.data?.Flight || [];

    if (!flights.length) return;

    // ✅ MULTIPLE FLIGHTS (optional UI later)
    if (flights.length > 1) {

     

        
        setMultiFlightData(flights((f) => ({
          ...f,
          selected: false
        })));
        setFilteredFlightData(flights);
      setFlightIndex(index);
      setFlightType(from)
        
        multiFlightOpen();


      console.log("Multiple flights found", flights);
      return;
    }

    const f = flights[0];

    const departure = f.departure;
    const arrival = f.arrival;

    const departureActual = departure?.actual || departure?.actual_runway || departure?.estimated || departure?.estimated_runway || departure?.scheduled;
    const arrivalActual = arrival?.actual || arrival?.actual_runway || arrival?.estimated || arrival?.estimated_runway || arrival?.scheduled
    const departureScheduled = departure?.scheduled;
        const arrivalScheduled = arrival.scheduled;
    

    const prefix = `${from}.${index}`;

    // ✅ ONLY RHF (NO STATE)
    

    setValue(`${prefix}.departure_iata_code`, departure.iata || "");
    setValue(`${prefix}.arrival_iata_code`, arrival.iata || "");

    if (isActual) {
      setValue(`${prefix}.actual_airport_of_origin`, departure.airport || "");
    setValue(`${prefix}.actual_airport_of_destination`, arrival.airport || "");
     
      setValue(`${prefix}.actual_departure_time`,  dateFormat(departureActual, departure.timeZone).time);
    setValue(`${prefix}.actual_departure_date`, dateFormat(departureActual, departure.timeZone).date);

    setValue(`${prefix}.actual_arrival_time`, dateFormat(arrival.arrivalActual, arrival.timeZone).time);
    setValue(`${prefix}.actual_arrival_date`, dateFormat(arrival.arrivalActual, arrival.timeZone).date);
 
    } else {
      setValue(`${prefix}.airport_of_origin`, departure.airport || "");
      setValue(`${prefix}.airport_of_destination`, arrival.airport || "");
      
      setValue(`${prefix}.original_departure_time`,dateFormat(departureScheduled, departure.timeZone).time);
    setValue(`${prefix}.original_departure_date`, dateFormat(departureScheduled, departure.timeZone).date);

    setValue(`${prefix}.original_arrival_time`, dateFormat(arrivalScheduled, arrival.timeZone).time);
    setValue(`${prefix}.original_arrival_date`,  dateFormat(arrivalScheduled, arrival.timeZone).date);

    // optionally also set actual (if API gives it)
  
      setValue(`${prefix}.actual_departure_time`,  dateFormat(departureActual, departure.timeZone).time);
      setValue(`${prefix}.actual_departure_date`,  dateFormat(departureActual, departure.timeZone).date);
    
      setValue(`${prefix}.actual_arrival_time`, dateFormat(arrivalActual, arrival.timeZone).time);
      setValue(`${prefix}.actual_arrival_date`, dateFormat(arrivalActual, arrival.timeZone).date);
  
    }

    // ✅ delay calculation
    const delay = getDelayDuration(
      arrival.scheduled,
      arrival.actual ||
        arrival.actual_runway ||
        arrival.estimated ||
        arrival.estimated_runway
    );

    setValue(`${prefix}.delay_duration_minutes`, delay || 0);

setBackdropOpen(false)
  } catch (err) {
    console.error("Error fetching flight:", err);

    const prefix = `${from}.${index}`;

    // ✅ RESET VALUES (RHF)
    setValue(`${prefix}.airport_of_origin`, "");
    setValue(`${prefix}.airport_of_destination`, "");
    setValue(`${prefix}.departure_iata_code`, "");
    setValue(`${prefix}.arrival_iata_code`, "");
    setValue(`${prefix}.delay_duration_minutes`, 0);
   
setBackdropOpen(false)
  } finally {
setBackdropOpen(false)
    
  }
};

   const isValidDate = (str) => {
          return moment(str, "MM-DD-YYYY", true).isValid();
        };

  const tryFetchFlight = (index, from) => {
    
    const flight = getValues(`${from}.${index}`);

    console.log(flight)

     const date =
    from === "actualFlights"
      ? flight?.actual_date_of_travel
      : flight?.date_of_travel;

  const hubCode =
    from === "actualFlights"
      ? flight?.actual_hub_code
      : flight?.hub_code;

  const flightNumber =
    from === "actualFlights"
      ? flight?.actual_flight_number
      : flight?.flight_number;

    if (
      hubCode &&
      flightNumber &&
      isValidDate(date)
    ) {
      fetchFlightOptions(index,from);
    }
  };
  const typingTimeouts = useRef({});
  useEffect(() => {
    return () => {
      Object.values(typingTimeouts.current).forEach((t) => clearTimeout(t));
    };
  }, []);

  const DEBOUNCE_MS = 600;





  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    if (ddmmyyyy.test(value) || yyyymmdd.test(value)) {
      return true;
    }

    return "Date must be in mm-dd-yyyy format";
  };





  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/flight_states_airports?search=${inputValue}&sortby=airport_name`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            value: airport.id,
            label: `${airport.airport_name.replace(
              /[\n\u0000-\u001F\u007F-\u009F]/g,
              ""
            )} (${airport.iata_code})`,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };


  const loadAirlineOptions = (inputValue, search_by, callback) => {
    fetchAirlines(inputValue, search_by).then((options) => callback(options));
  };

  const fetchInitialAirports = async () => {
    try {
      // Fetch initial airline options
      const airlineResponse = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airlines?sortby=airline_name`
      );
      if (airlineResponse.data && airlineResponse.data.Airlines) {
        const airlineOptions = airlineResponse.data.Airlines.map((airline) => ({
          value: airline.id,
          label: `${airline.airline_name} ${airline.iata_code ? `(${airline.iata_code})` : ""
            }`,
          hub_code: airline.iata_code,
        }));
        setDefaultAirlineOptions(airlineOptions);
      }

      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`
      );
      if (response.data && response.data.Airports) {
        const options = response.data.Airports.map((airport) => ({
          value: airport.id,
          label: `${airport.airport_name.replace(
            /[\n\u0000-\u001F\u007F-\u009F]/g,
            ""
          )} (${airport.iata_code})`,
        }));

        setDefaultAirportOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  useEffect(() => {

    fetchInitialAirports();
  }, []);





  const fetchAirlines = async (inputValue, search_by) => {
    if (inputValue.length === 0) return [];

    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airlines?${search_by}=${inputValue}`
      );

      if (!response.data || !response.data.Airlines) return [];

      const airlines = response.data.Airlines.map((airline) => ({
        value: airline.id,
        label: `${airline.airline_name} ${airline.iata_code ? `(${airline.iata_code})` : ""
          }`,
        airline_name: airline?.airline_name || "",
        iata_code: airline?.iata_code || "",

        hub_code: airline.icao_code,
      }));

      const search = inputValue.toLowerCase();

      // 1️⃣ EXACT MATCH
      const exact = airlines.filter((a) =>
        a.iata_code.toLowerCase() === search ||
        a.airline_name.toLowerCase() === search
      );

      // 2️⃣ STARTS WITH
      const startsWith = airlines.filter((a) =>
        (a.iata_code.toLowerCase().startsWith(search) ||
          a.airline_name.toLowerCase().startsWith(search)) &&
        !(a.iata_code.toLowerCase() === search ||
          a.airline_name.toLowerCase() === search)
      );

      // 3️⃣ CONTAINS ANYWHERE
      const contains = airlines.filter((a) =>
        (a.iata_code.toLowerCase().includes(search) ||
          a.airline_name.toLowerCase().includes(search)) &&
        !(
          a.iata_code.toLowerCase().startsWith(search) ||
          a.airline_name.toLowerCase().startsWith(search)
        )
      );

      return [...exact, ...startsWith, ...contains];
    } catch (error) {
      console.error("Error fetching airlines:", error);
      return [];
    }
  };

 const addCustomerNote = (customerNote, notes) => {
    const trimmedNote = customerNote?.trim();

    // Don't add the note if it's empty, null, or only contains spaces
    if (!trimmedNote) {
      return notes ? notes : null;
    }

    const dateTime = moment().format("h:mm A MMMM D, YYYY");
    const newNote = {
      user: "customer",
      note: trimmedNote,
      timestamp: dateTime,
    };

    return notes ? [newNote, ...notes] : [newNote];
  };


  const scrollToError = () => {
  const firstError = document.querySelector(".error-text");

  if (firstError) {
    firstError.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
};
const [isClaimId,setClaimId]=useState(null)
   const onSubmit = (data) => {
     if (!pdfBlob) {
          Swal.fire({
            icon: "error",
            title: "Agreement need to be signed",
          });
          return;
        }
     console.log("Form Data", data);

     const flightDetails = data.originalFlights
     const actualFlightDetails = data.actualFlights
     const type_of_claim = data.groupDetails.type_of_claim;
     const personal_info = data.personalInfo;
 
     const formData = new FormData();
 
 
 
     const updatedNotes = addCustomerNote(personal_info.note, "");
 
    
 
   
     const familyMembersData = travelers.map((member, index) => {
       const memberData = {
         first_name: member?.first_name?.trim(),
         last_name: member.last_name,
         date_of_birth: member.date_of_birth,
         passport_number: member.passport_number,
         tickets: member.tickets,
         country: member.country,
         airline_res_no: member.airline_res_no,
       };
 
       if (member.passport && member.passport_name) {
         memberData.passport = member.passport_name;
         formData.append(member.passport_name, member.passport);
       }
       if (member.additional_doc && member.additionalDoc_name) {
         memberData.additional_doc = member.additionalDoc_name;
         formData.append(member.additionalDoc_name, member.additional_doc);
       }
       if (member.boarding_pass && member.boardingpass_name) {
         memberData.boarding_pass = member.boardingpass_name;
         formData.append(member.boardingpass_name, member.boarding_pass);
       }
       if (isClaimId) {
         if (member.id !== null) {
           memberData.id = member.id;
         }
       }
 
       return memberData;
     });


     console.log(familyMembersData);
     
     const formattedFlightDetails = flightDetails.map((flight, index) => {
 
 
 
       const flightData = {
         airline: flight.airline,
         airline_code: flight?.hub_code,
         flight_number: flight.flight_number,
         airport_of_origin: flight.airport_of_origin,
         airport_of_destination: flight.airport_of_destination,
         scheduled_arrival: `${formatToYYYYMMDD(flight.original_arrival_date)}T${flight.original_arrival_time &&
           flight.original_arrival_time.trim() !== ""
           ? flight.original_arrival_time
           : "00:00"
           }`,
         scheduled_departure: `${formatToYYYYMMDD(flight.date_of_travel)}T${flight.original_departure_time &&
           flight.original_departure_time.trim() !== ""
           ? flight.original_departure_time
           : "00:00"
           }`,
         date_of_travel: formatToYYYYMMDD(flight.date_of_travel),
         disruption: flight.delayed
           ? "delayed"
           : flight.cancelled
             ? "cancelled"
             : flight.missed
               ? "missed"
               : flight.denied
                 ? "denied"
                 : flight.downgraded
                   ? "downgraded"
                   : flight.disruption,
         delay_duration: flight.delay_duration === "none" ? null : flight.delay_duration,
         delay_cal: flight.delay_duration_minutes || 0,
         flight_cancel: flight.flight_cancel,
         missed_connection: flight.missed_connection,
         // claim_details: flight.claim_details,
         additional_details: flight.additional_details,
         ticket_ref_no: flight.ticket_ref_no,
         delayed: flight.disruption === "delayed",
         cancelled: flight.disruption === "cancelled",
         missed: flight.disruption === "missed",
         denied: flight.disruption === "denied",
         downgraded: flight.disruption === "downgraded",
         cancellation_info_before: flight.cancellation_info_before,
         cancellation_info_at_airport: flight.cancellation_info_at_airport,
         missed_due_to_error: flight.missed_due_to_error,
         missed_due_to_personal: flight.missed_due_to_personal,
         flight_class: flight.flight_class,
         sequence: index + 1
       };
 
       if (isClaimId) {
         if (flight.id !== null) {
           flightData.id = flight.id;
         }
       }
 
       return flightData;
     });
 

      const actualFlightDetailsData = actualFlightDetails.map((flight,index) => {
      const newData = {
        actual_departure: `${formatToYYYYMMDD(flight.actual_date_of_travel)}T${flight.actual_departure_time}`,
        actual_arrival: `${formatToYYYYMMDD(flight.actual_arrival_date)}T${flight.actual_arrival_time}`,
        actual_airport_of_origin: flight.actual_airport_of_origin,
        actual_date_of_travel: formatToYYYYMMDD(flight.actual_date_of_travel),
        ticket_ref_no: flight.ticket_ref_no,
        actual_airport_of_destination: flight.actual_airport_of_destination,
        actual_airline: flight.actual_airline,
        actual_flight_number: flight.actual_flight_number,
        provided_by_airline: flight.flight_provider === "provided_by_airline",
        self_booked: flight.flight_provider === "self_booked",
        actual_flight_class: flight.actual_flight_class,
        airline_code: flight?.actual_hub_code,
        sequence: index + 1

      };
      
      return newData;
    });
    

     
 
 
 
 
     // Now, you can use `formattedFlightDetails` to send to the API.
 
     console.log(type_of_claim)
     ////console.log("Family Details", familyMembersData);
 console.log("actual flight details =============> ",actualFlightDetailsData)
     let formObject = {
       first_name: personal_info?.first_name?.trim(),
       last_name: personal_info?.last_name,
       address: personal_info?.address,
       passport_number: personal_info?.passport_number,
       unit: personal_info?.unit,
       nationality: personal_info?.country,
       date_of_birth: formatToYYYYMMDD(personal_info?.date_of_birth),
       airline_res_no: personal_info?.airline_res_no,
       flight_details: (type_of_claim !== 'lost/damaged' && type_of_claim !== "lost_wages") ? formattedFlightDetails : [],
       actual_flight_details: type_of_claim !== "cancelled" ? actualFlightDetailsData : [],
      //  type_of_claim !== "cancelled" ? actualFlighDetailsData : [],
       source_of_claim: "flyandclaim",
       contact_no: personal_info?.contact_no,
       email_id: personal_info?.email_id,
       delay: (type_of_claim !== 'denied_boarding' && type_of_claim !== 'other' && type_of_claim !== 'lost/damaged' && type_of_claim !== 'lost_wages') ? getNewDelayDuration(true) : null,
       note: updatedNotes,
       sub_claims: familyMembersData,
       envelope_id: envolpeId,
       agreement_signed: true,
       agreement_url: agreementUrl,
       type_of_claim: type_of_claim,
       tickets: personal_info?.tickets,
       num_of_passenger: data?.groupDetails?.passengers,
       postal_code: personal_info?.postal_code,
       state: personal_info?.state,
       city: personal_info?.city,
       other_claims: null,
       signers: signers,
       travelers:data?.groupDetails?.passengers,
       status: "incomplete",
       claim_amount: data?.claim_amount,
       luggage_delivered:  type_of_claim === "lost/damaged" ? moment(data?.luggage_delivered).format("YYYY-MM-DD") : null,
 
       delay_duration_minutes: getNewDelayDuration(),
         group_name: data?.groupDetails?.group_name ?? null,
      group:true
     };
    
 
     // Convert the form object to JSON
     const jsonFormObject = JSON.stringify(formObject);
 
     // Append the JSON object to the FormData
     formData.append("data", jsonFormObject);
 
     // Safely access the files or use an empty array
 
     // Append file fields
     // formData.append(
     //   "boarding_pass",
     //   getformData?.uploadDocuments?.boarding_pass?.[0] || null // Fallback to null
     // );
 
     formData.append(
       "boarding_pass",
       personal_info?.boarding_pass?.[0] || null // Fallback to null
     );
 
     formData.append(
       "passport",
       personal_info?.passport?.[0] || null // Fallback to null
     );
     formData.append("additional_exp", null);
     // formData.append(
     //   "passport",
     //   getformData?.uploadDocuments?.passport?.[0] || null // Fallback to null
     // );
 
     if (data?.additional_files) {
       for (let i = 0; i < data?.additional_files.length; i++) {
         formData.append("document", data?.additional_files[i]);
       }
     }
 

       if (data?.luggage_file) {
      formData.append("baggage_claim", data?.luggage_file?.[0]);
      
    }
    
     if (pdfBlob) {
       const pdfFile = new File([pdfBlob], "agreement.pdf", {
         type: "application/pdf",
       });
       //console.log("INSIDE PDFFILE", pdfFile);
 
       formData.append("agreement", pdfFile);
     }
 
     if (powerPdf) {
       const pdfFile = new File([powerPdf], "power_of_attorney.pdf", {
         type: "application/pdf",
       });
 
       formData.append("power_of_attorney", pdfFile);
     }
 
     console.log("Final Submitted Data ==================>", formData);
 
     setBackdropOpen(true);
 
     saveCompensation(formData);
 
     // if (!isClaimId) {
     //   saveCompensation(formData);
     // }
 
     // if (isClaimId) {
     //   postClaimRequest(formData);
     //   // setclaimid(formObject?.contact_no);
     // }
   };
  
   const saveCompensation = (formData) => {
      axios
        .post(`${base_url.api1}/tourapp/compensation_request`, formData, {
          headers: {
            Origin: "https://flyandclaim.odisoft.in",
          },
        })
        .then(
          async (response) => {
            ////console.log(response);
            if (response.status === 200) {
  
  
             
              setBackdropOpen(false);
  
              setSuccessResponse(true)
              successModalOpen();

  
  
  
            } else {
              setBackdropOpen(false);
               setSuccessResponse(false)
              successModalOpen();
            }
           
          },
          (error) => {

             setSuccessResponse(false)
              successModalOpen();
            // Swal.fire({
            //   icon: "error",
            //   title: "Network Error",
            //   text: "There was a problem connecting to the server. Please try again later.",
            // });
  
            setBackdropOpen(false);
           
          }
        );
    };



  return (
    <div className="group-claim-wrapper">

       <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>


      <form onSubmit={handleSubmit(onSubmit)} className="group-claim-form">

        {/* ================= GROUP DETAILS ================= */}
        <h2 className="group-claim-header">Group Details</h2>

        <div className="group-claim-input-grid">

          <div className="group-claim-input-wrapper">
            <label >Group Name <span style={{ color: "red" }}>*</span></label>

            <Controller
              name="groupDetails.group_name"
              control={control}
              rules={{
                required: "Enter Group Name",
              }}
              render={({ field }) => (
                <TextInput
                  hideControls
                  placeholder="Enter Group Name"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.groupDetails?.group_name && (
              <p className="error-text">{errors.groupDetails?.group_name?.message}</p>
            )}
          </div>
          <div className="group-claim-input-wrapper">
            <label className="input-label">Select Claim Type <span style={{ color: "red" }}>*</span></label>

            <Controller
              name="groupDetails.type_of_claim"
              control={control}
              rules={{ required: "Please select claim type" }}
              render={({ field }) => (


                <Select
                  placeholder="Select Claim"
                  data={[
                    { value: "delayed", label: "Flight Delayed" },
                    { value: "cancelled", label: "Flight Cancelled" },
                    { value: "denied_boarding", label: "Denied Boarding" },
                    { value: "lost/damaged", label: "Lost/Damaged/Delayed Baggage" },
                    { value: "lost_wages", label: "Lost Wages" },
                    { value: "other", label: "Other Issue" },
                  ]}
                  rightSection={<SelectIcon />}
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.groupDetails?.type_of_claim && (
              <p className="error-text">{errors.groupDetails?.type_of_claim.message}</p>
            )}
          </div>

          <div className="group-claim-input-wrapper">
            <label >Number of Passengers <span style={{ color: "red" }}>*</span></label>

            <Controller
              name="groupDetails.passengers"
              control={control}
              rules={{
                required: "Enter Number of Passengers",
              }}
              render={({ field }) => (
                <NumberInput
                  readOnly
                  hideControls
                  placeholder="Number of Passengers"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.groupDetails?.passengers && (
              <p className="error-text">{errors.groupDetails?.passengers?.message}</p>
            )}
          </div>
        </div>

        {/* ================= ORIGINAL FLIGHTS ================= */}

        {
                        (watch('groupDetails.type_of_claim') !== "lost/damaged" && watch('groupDetails.type_of_claim') !== "lost_wages") && <div className="group-claim-section">
          <h2 className="group-claim-header">Original Flights</h2>

          {originalFlights.map((item, index) => {
            const searchBy = watch(`originalFlights.${index}.search_by`);
            const disruption = watch(`originalFlights.${index}.disruption`);
            const manual = watch(`originalFlights.${index}.manual`);

            return (
              <div key={item.id} className="group-flight-box" >

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h3 className="group-claim-header" style={{ fontSize: '20px' }}>Flight {index + 1}</h3>
                  {originalFlights.length > 1 && (
                    <div
                      style={{
                        backgroundColor: "none",
                        color: "red",
                        cursor: "pointer",
                        marginLeft: "2px",
                        textAlign: "right",
                      }}
                      onClick={() => removeOriginalFlights(index)}
                    >
                      <RemoveCircleOutline />
                    </div>
                  )}
                </div>
                <div className="group-claim-input-wrapper">
                  <label>Search By</label>



                  <Controller
                    name={`originalFlights.${index}.search_by`}
                    control={control}

                    render={({ field }) => (

                      <Radio.Group
                        value={field.value}
                        onChange={(v) => field.onChange(v)}
                      >
                        <div className="claim-form-radio-wrapper">

                          <Radio
                            color="red"
                            // checked
                            variant="outline"
                            value={"airline_name"}
                            label="Airline name"
                            size="xs"
                          />

                          <Radio
                            color="red"
                            variant="outline"
                            value={"iata_code"}
                            label="Airline code"
                            size="xs"

                          />
                        </div>
                      </Radio.Group>

                    )}
                  />


                </div>
                <div className="group-claim-input-grid">
                  <div className="group-claim-input-wrapper">
                    <label className="input-label">Airline <span style={{ color: "red" }}>*</span></label>

                    <Controller
                      name={`originalFlights.${index}.airline`}
                      control={control}
                      rules={{ required: "Airline is required" }}
                      render={({ field }) => (
                        <AsyncSelect
                          {...field}
                          cacheOptions={false}
                          defaultOptions={defaultAirlineOptions}
                          loadOptions={(inputValue, callback) =>
                            loadAirlineOptions(inputValue, searchBy || "airline_name", callback)
                          }
                          value={
                            field.value
                              ? {
                                label: field.value,
                                value: field.value,
                              }
                              : null
                          }
                          placeholder="Choose airline"
                          onChange={(selectedOption) => {

                            field.onChange(selectedOption?.label || "");

                            console.log(selectedOption?.hub_code)
                            setValue(
                              `originalFlights.${index}.hub_code`,
                              selectedOption?.hub_code || ""
                            );

                            setValue(
                              `originalFlights.${index}.iata_code`,
                              selectedOption?.iata_code || ""
                            );

                            tryFetchFlight(index,"originalFlights");
                          }}
                          styles={selectStyles}
                        />
                      )}
                    />

                    {errors.originalFlights?.[index]?.airline && (
                      <p className="error-text">{errors.originalFlights?.[index]?.airline.message}</p>
                    )}

                  </div>


                  <div className="group-claim-input-wrapper">
                    <label >Flight Number (digits only) <span style={{ color: "red" }}>*</span></label>

                    <Controller
                      name={`originalFlights.${index}.flight_number`}
                      control={control}
                      rules={{
                        required: "Enter Flight Number",
                      }}
                      render={({ field }) => (
                        <NumberInput
                          hideControls
                          placeholder="Enter Flight Number"
                          value={field.value}
                          onChange={(v) => {
                            // ✅ normalize value
                            const value = v?.toString() || "";

                            field.onChange(value);

                            // ✅ clear previous timeout
                            if (typingTimeouts.current[index]) {
                              clearTimeout(typingTimeouts.current[index]);
                            }

                            // ✅ debounce
                            typingTimeouts.current[index] = setTimeout(() => {
                              if (value.trim().length > 0) {
                                                            tryFetchFlight(index,"originalFlights");

                              }

                              delete typingTimeouts.current[index];
                            }, 500);
                          }}
                        />
                      )}
                    />

                    {errors.originalFlights?.[index]?.flight_number && (
                      <p className="error-text">{errors.originalFlights?.[index]?.flight_number?.message}</p>
                    )}
                  </div>

                  <div className="group-claim-input-wrapper">
                    <label >Scheduled departure date & time <span style={{ color: "red" }}>*</span></label>




                    <div className="custom-date-time-container">


                      <div className="custom-date-time-box" style={{ position: 'relative' }}>

                        {/* DATE */}
                        <Controller
                          name={`originalFlights.${index}.date_of_travel`}
                          control={control}
                          rules={{
                            required: "Departure Date is required",
                            validate: validateDateFormat,
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <CustomDOBPicker
                                {...field}
                                placeholder="Choose date"
                                inputClassName="custom-date-input"
                                inputRequired={true}
                                
                                onChange={(value) => {
                                  field.onChange(value);
                            tryFetchFlight(index,"originalFlights");

                                }}
                                error={fieldState.error?.message}
                              />
                            </>
                          )}
                        />

                        {/* TIME */}
                        <Controller
                          name={`originalFlights.${index}.original_departure_time`}
                          control={control}
                          rules={{
                            required: "Departure Time is required",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <input
                                {...field}
                                type="time"
                                className="custom-time-input"
                                disabled={!manual}
                              />
                            </>
                          )}
                        />
                      </div>


                    </div>


                    {/* ERROR */}
                    {(errors.originalFlights?.[index]?.date_of_travel ||
                      errors.originalFlights?.[index]?.original_departure_time) && (
                        <p className="error-text">
                          {errors.originalFlights?.[index]?.date_of_travel?.message ||
                            errors.originalFlights?.[index]?.original_departure_time?.message ||
                            "Departure Date and Time is Required"}
                        </p>
                      )}


                  </div>


                  <div className="group-claim-input-wrapper">
                    <label >Airport of origin <span style={{ color: "red" }}>*</span></label>


                    <Controller
                      name={`originalFlights.${index}.airport_of_origin`}
                      control={control}
                      rules={{ required: "Origin airport is required" }}
                      render={({ field }) => (
                        <AsyncSelect
                          {...field}
                          styles={selectStyles}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={defaultAirportOptions}
                          placeholder="Select Origin Airport"
                          isDisabled={!manual}
                          value={
                            field.value
                              ? { label: field.value, value: field.value }
                              : null
                          }

                          onChange={(option) => {
                            field.onChange(option?.label || "");
                          }}
                        />
                      )}
                    />

                      {errors.originalFlights?.[index]?.airport_of_origin && (
                      <p className="error-text">{errors.originalFlights?.[index]?.airport_of_origin.message}</p>
                    )}

                  </div>




                  <div className="group-claim-input-wrapper">
                    <label >Scheduled arrival date & time <span style={{ color: "red" }}>*</span></label>




                    <div className="custom-date-time-container">


                      <div className="custom-date-time-box">

                        {/* DATE */}
                        <Controller
                          name={`originalFlights.${index}.original_arrival_date`}
                          control={control}
                          rules={{
                            required: "Arrival Date is required",
                            validate: validateDateFormat,
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <CustomDOBPicker
                                {...field}
                                placeholder="Choose date"
                                inputRequired={true}

                                inputClassName="custom-date-input"
                                disabled={!manual}
                                error={fieldState.error?.message}
                              />
                            </>
                          )}
                        />

                        {/* TIME */}
                        <Controller
                          name={`originalFlights.${index}.original_arrival_time`}
                          control={control}
                          rules={{
                            required: "Arrival Time is required",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <input
                                {...field}
                                type="time"
                                className="custom-time-input"
                                disabled={!manual}
                              />
                            </>
                          )}
                        />
                      </div>


                    </div>


                    {/* ERROR */}
                    {(errors.originalFlights?.[index]?.original_arrival_date ||
                      errors.originalFlights?.[index]?.original_arrival_time) && (
                        <p className="error-text">
                          {errors.originalFlights?.[index]?.original_arrival_date?.message ||
                            errors.originalFlights?.[index]?.original_arrival_time?.message ||
                            "Arrival Date and Time is Required"}
                        </p>
                      )}


                  </div>


                  <div className="group-claim-input-wrapper">
                    <label >Airport of destination <span style={{ color: "red" }}>*</span></label>


                    <Controller
                      name={`originalFlights.${index}.airport_of_destination`}
                      control={control}
                      rules={{ required: "Destination airport is required" }}
                      render={({ field }) => (
                        <AsyncSelect
                          {...field}
                          styles={selectStyles}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={defaultAirportOptions}
                          placeholder="Select Destination Airport"
                          isDisabled={!manual}


                          value={
                            field.value
                              ? { label: field.value, value: field.value }
                              : null
                          }

                          onChange={(option) => {
                            field.onChange(option?.label || "");
                          }}
                        />
                      )}
                    />

                      {errors.originalFlights?.[index]?.airport_of_destination && (
                      <p className="error-text">{errors.originalFlights?.[index]?.airport_of_destination.message}</p>
                    )}
                    

                  </div>


                  <div className="group-claim-input-wrapper">
                    <label className="input-label">Flight Class <span style={{ color: "red" }}>*</span></label>

                    <Controller
                      name={`originalFlights.${index}.flight_class`}
                      control={control}
                      rules={{ required: "Please select Flight Class" }}
                      render={({ field }) => (


                        <Select
                          placeholder="Select Flight Class"
                          data={flightClassOptions}
                          rightSection={<SelectIcon />}
                          value={field.value}
                          onChange={(v) => field.onChange(v)}
                        />
                      )}
                    />

                    {errors.originalFlights?.[index]?.flight_class && (
                      <p className="error-text">{errors.originalFlights?.[index]?.flight_class.message}</p>
                    )}
                  </div>


                  <div className="group-claim-input-wrapper">
                    <label className="input-label">Flight info didn't appear ?</label>
                    <button className="btn btn-manual" type="button" onClick={() => {
                      setValue(`originalFlights.${index}.manual`, true);
                    }} >

                      enter manually

                    </button>

                  </div>


                </div>

               
                <div className="group-claim-non-grid">
                  <div className="group-claim-input-wrapper">
                    <label >What was the issue with this flight?</label>
                  <div className="group-radio-btn-wrapper">
                    <Controller
                      name={`originalFlights.${index}.disruption`}
                      control={control}
                      render={({ field }) => (
                        <>
                          {[
                            { label: "Flight delayed", value: "delayed" },
                            { label: "Flight canceled", value: "cancelled" },
                            { label: "Missed Connection", value: "missed" },
                            { label: "Denied Boarding", value: "denied" },
                            { label: "Downgraded", value: "downgraded" },
                            { label: "None of these", value: "none" },
                          ].map((item) => (
                            <div key={item.value} className="group-claim-radio-btn" onClick={() => field.onChange(item.value)}>
                              <input
                                id={`disruption_${index}_${item.value}`}
                                type="radio"
                                name={field.name}
                                value={item.value}
                                checked={field.value === item.value}
                                onChange={() => field.onChange(item.value)}
                              />
                              <label htmlFor={`disruption_${index}_${item.value}`}>{item.label}</label>
                            </div>
                          ))}
                        </>
                      )}
                    />
                    </div>
                    
                    </div>

                  {
                    (disruption === "delayed" || disruption === "cancelled" || disruption === "missed") &&   <div className="group-claim-input-wrapper">
                    <label > {disruption === "delayed"
                      ? "How long was your delay?"
                      : disruption === "cancelled"
                        ? "When were you informed about the cancellation?"
                        : disruption === "missed"
                          ? "Why did you miss your flight?"
                          : ""}</label>
                 

                  <div className="group-radio-btn-wrapper">
                    {/* ✅ CONDITIONAL UI */}
                    {disruption === "delayed" && (
                      <Controller
                        name={`originalFlights.${index}.delay_duration`}
                        control={control}
                        render={({ field }) => (
                          <>
                            {[
                              { label: "Less than 3 hours", value: "179" },
                              { label: "3–4 hours", value: "181" },
                              { label: "4+ hours", value: "241" },
                              { label: "None of these", value: "none" },
                            ].map((item) => (
                              <div key={item.value} className="group-claim-radio-btn" onClick={() => field.onChange(item.value)}>
                                <input
                                  id={`disruption_delay_${index}_${item.value}`}
                                  type="radio"
                                  value={item.value}
                                  name={field.name}
                                  checked={field.value === item.value}

                                />
                                <label htmlFor={`disruption_delay_${index}_${item.value}`} >{item.label}</label>
                              </div>
                            ))}
                          </>
                        )}
                      />
                    )}



                    {disruption === "cancelled" && (
                      <Controller
                        name={`originalFlights.${index}.flight_cancel`}
                        control={control}
                        render={({ field }) => (
                          <>

                            <div className="group-claim-radio-btn" onClick={() => field.onChange("cancellation_info_before")}>
                              <input
                                type="radio"
                                value="cancellation_info_before"
                                name={field.name}
                                checked={field.value === "cancellation_info_before"}

                              />
                              <label>Before arriving at the airport</label>


                            </div>

                            <div className="group-claim-radio-btn" onClick={() => field.onChange("cancellation_info_at_airport")}>

                              <input
                                type="radio"
                                value="cancellation_info_at_airport"
                                name={field.name}
                                checked={field.value === "cancellation_info_at_airport"}

                              />
                              <label>At the airport</label>

                            </div>

                            <div className="group-claim-radio-btn" onClick={() => field.onChange("none")}>

                              <input
                                type="radio"
                                value="none"
                                name={field.name}
                                checked={field.value === "none"}

                              />
                              <label>None of these</label>

                            </div>

                          </>
                        )}
                      />
                    )}


                    {disruption === "missed" && (
                      <Controller
                        name={`originalFlights.${index}.missed_connection`}
                        control={control}
                        render={({ field }) => (
                          <>

                            <div className="group-claim-radio-btn" onClick={() => field.onChange("missed_due_to_error")}>
                              <input
                                type="radio"
                                value="missed_due_to_error"
                                name={field.name}
                                checked={field.value === "missed_due_to_error"}

                              />
                              <label>Airline action</label>


                            </div>

                            <div className="group-claim-radio-btn" onClick={() => field.onChange("missed_due_to_personal")}>

                              <input
                                type="radio"
                                value="missed_due_to_personal"
                                name={field.name}
                                checked={field.value === "missed_due_to_personal"}

                              />
                              <label>Personal reasons</label>

                            </div>


                            <div className="group-claim-radio-btn" onClick={() => field.onChange("none")}>

                              <input
                                type="radio"
                                value="none"
                                name={field.name}
                                checked={field.value === "none"}

                              />
                              <label>None of these</label>

                            </div>

                          </>
                        )}
                      />
                    )}

                    </div>
                    
                  </div>
                 }
                
                  
                  <div className="group-claim-input-wrapper">
                    <label >Additional details</label>
                  <Controller
                                        name={`originalFlights.${index}.additional_details`}
                                        control={control}
                                        render={({ field }) => (
                                          <textarea
                                            {...field}
                                            className="group-claim-textarea"
                                            rows={5}
                                            placeholder="Add any relevant details about your delayed flight"
                                           
                                          />
                                        )}
                    />
                    
                    </div>


                </div>

               
              </div>
            )
          })}


          <button className="btn btn-manual" type="button" onClick={() => addOriginalFlights({ search_by: 'airline_name',flight_class:'Economy' })}>

            Add original flight

          </button>

        </div>

        }
        


        {/* ================= ACTUAL FLIGHTS ================= */}

       
        {
           watch('groupDetails.type_of_claim') !== "cancelled" &&  <div className="group-claim-section">
          <h2 className="group-claim-header">Actual Flights</h2>

          {actualFlights.map((item, index) => {
            const searchBy = watch(`actualFlights.${index}.search_by`);
            const manual = watch(`actualFlights.${index}.manual`);

            return (
              <div key={item.id} className="group-flight-box" >

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h3 className="group-claim-header" style={{ fontSize: '20px' }}>Flight {index + 1}</h3>
                  {actualFlights.length > 1 && (
                    <div
                      style={{
                        backgroundColor: "none",
                        color: "red",
                        cursor: "pointer",
                        marginLeft: "2px",
                        textAlign: "right",
                      }}
                      onClick={() => removeActualFlights(index)}
                    >
                      <RemoveCircleOutline />
                    </div>
                  )}
                </div>


                <Controller
  name={`actualFlights.${index}.same_as_original`}
  control={control}
  defaultValue={false}
  render={({ field }) => (
    <label className="actual-flight-check-box-wrapper" style={{marginTop:'0px',marginBottom:'30px'}}>
      <input
        type="checkbox"
        className="form-check-input attorney-notes-checkbox-input"
        checked={field.value || false}
        onChange={(e) => {
          const checked = e.target.checked;

          field.onChange(checked); // ✅ update RHF

          const original = getValues(`originalFlights.${index}`);
          const prefix = `actualFlights.${index}`;

          if (checked) {
            // ✅ COPY DATA (RHF ONLY)
            setValue(`${prefix}.actual_airline`, original?.airline || "");
            setValue(`${prefix}.actual_hub_code`, original?.hub_code || "");
            setValue(`${prefix}.actual_airport_of_origin`, original?.airport_of_origin || "");
            setValue(`${prefix}.actual_flight_number`, original?.flight_number || "");
            setValue(`${prefix}.actual_airport_of_destination`, original?.airport_of_destination || "");

            setValue(`${prefix}.actual_date_of_travel`, original?.actual_departure_date || "");
            setValue(`${prefix}.actual_departure_time`, original?.actual_departure_time || "");
            setValue(`${prefix}.actual_arrival_date`, original?.actual_arrival_date || "");
            setValue(`${prefix}.actual_arrival_time`, original?.actual_arrival_time || "");

            setValue(`${prefix}.actual_flight_class`, original?.flight_class || "");
          } else {
            // ✅ CLEAR DATA
            setValue(`${prefix}.actual_airline`, "");
            setValue(`${prefix}.actual_hub_code`, "");
            setValue(`${prefix}.actual_airport_of_origin`, "");
            setValue(`${prefix}.actual_flight_number`, "");
            setValue(`${prefix}.actual_airport_of_destination`, "");

            setValue(`${prefix}.actual_date_of_travel`, "");
            setValue(`${prefix}.actual_departure_time`, "");
            setValue(`${prefix}.actual_arrival_date`, "");
            setValue(`${prefix}.actual_arrival_time`, "");

            setValue(`${prefix}.actual_flight_class`, "");
          }
        }}
      />
      Same as Original Flight
    </label>
  )}
/>
                <div className="group-claim-input-wrapper">
                  <label>Search By</label>



                  <Controller
                    name={`actualFlights.${index}.search_by`}
                    control={control}

                    render={({ field }) => (

                      <Radio.Group
                        value={field.value}
                        onChange={(v) => field.onChange(v)}
                      >
                        <div className="claim-form-radio-wrapper">

                          <Radio
                            color="red"
                            // checked
                            variant="outline"
                            value={"airline_name"}
                            label="Airline name"
                            size="xs"
                          />

                          <Radio
                            color="red"
                            variant="outline"
                            value={"iata_code"}
                            label="Airline code"
                            size="xs"

                          />
                        </div>
                      </Radio.Group>

                    )}
                  />


                </div>
                <div className="group-claim-input-grid">
                  <div className="group-claim-input-wrapper">
                    <label className="input-label">Airline <span style={{ color: "red" }}>*</span></label>

                    <Controller
                      name={`actualFlights.${index}.actual_airline`}
                      control={control}
                      rules={{ required: "Airline is required" }}
                      render={({ field }) => (
                        <AsyncSelect
                          {...field}
                          cacheOptions={false}
                          defaultOptions={defaultAirlineOptions}
                          loadOptions={(inputValue, callback) =>
                            loadAirlineOptions(inputValue, searchBy || "airline_name", callback)
                          }
                          value={
                            field.value
                              ? {
                                label: field.value,
                                value: field.value,
                              }
                              : null
                          }
                          placeholder="Choose airline"
                          onChange={(selectedOption) => {

                            field.onChange(selectedOption?.label || "");

                            console.log(selectedOption?.hub_code)
                            setValue(
                              `actualFlights.${index}.actual_hub_code`,
                              selectedOption?.hub_code || ""
                            );

                            setValue(
                              `actualFlights.${index}.actual_iata_code`,
                              selectedOption?.iata_code || ""
                            );

                            tryFetchFlight(index,"actualFlights");
                          }}
                          styles={selectStyles}
                        />
                      )}
                    />

                    {errors.actualFlights?.[index]?.actual_airline && (
                      <p className="error-text">{errors.actualFlights?.[index]?.actual_airline.message}</p>
                    )}

                  </div>


                  <div className="group-claim-input-wrapper">
                    <label >Flight Number (digits only) <span style={{ color: "red" }}>*</span></label>

                    <Controller
                      name={`actualFlights.${index}.actual_flight_number`}
                      control={control}
                      rules={{
                        required: "Enter Flight Number",
                      }}
                      render={({ field }) => (
                        <NumberInput
                          hideControls
                          placeholder="Enter Flight Number"
                          value={field.value}
                          onChange={(v) => {
                            // ✅ normalize value
                            const value = v?.toString() || "";

                            field.onChange(value);

                            // ✅ clear previous timeout
                            if (typingTimeouts.current[index]) {
                              clearTimeout(typingTimeouts.current[index]);
                            }

                            // ✅ debounce
                            typingTimeouts.current[index] = setTimeout(() => {
                              if (value.trim().length > 0) {
                                                            tryFetchFlight(index,"actualFlights");

                              }

                              delete typingTimeouts.current[index];
                            }, 500);
                          }}
                        />
                      )}
                    />

                    {errors.actualFlights?.[index]?.actual_flight_number && (
                      <p className="error-text">{errors.actualFlights?.[index]?.actual_flight_number?.message}</p>
                    )}
                  </div>

                  <div className="group-claim-input-wrapper">
                    <label >Departure date & time <span style={{ color: "red" }}>*</span></label>




                    <div className="custom-date-time-container">


                      <div className="custom-date-time-box" style={{ position: 'relative' }}>

                        {/* DATE */}
                        <Controller
                          name={`actualFlights.${index}.actual_date_of_travel`}
                          control={control}
                          rules={{
                            required: "Departure Date is required",
                            validate: validateDateFormat,
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <CustomDOBPicker
                                {...field}
                                placeholder="Choose date"
                                inputClassName="custom-date-input"
                                inputRequired={true}
                                onChange={(value) => {
                                  field.onChange(value);
                            tryFetchFlight(index,"actualFlights");

                                }}
                                error={fieldState.error?.message}
                              />
                            </>
                          )}
                        />

                        {/* TIME */}
                        <Controller
                          name={`actualFlights.${index}.actual_departure_time`}
                          control={control}
                          rules={{
                            required: "Departure Time is required",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <input
                                {...field}
                                type="time"
                                className="custom-time-input"
                                disabled={!manual}
                              />
                            </>
                          )}
                        />
                      </div>


                    </div>


                    {/* ERROR */}
                    {(errors.actualFlights?.[index]?.actual_date_of_travel ||
                      errors.actualFlights?.[index]?.actual_departure_time) && (
                        <p className="error-text">
                          {errors.actualFlights?.[index]?.actual_date_of_travel?.message ||
                            errors.actualFlights?.[index]?.actual_departure_time?.message ||
                            "Departure Date and Time is Required"}
                        </p>
                      )}


                  </div>


                  <div className="group-claim-input-wrapper">
                    <label >Airport of origin <span style={{ color: "red" }}>*</span></label>


                    <Controller
                      name={`actualFlights.${index}.actual_airport_of_origin`}
                      control={control}
                      rules={{ required: "Origin airport is required" }}
                      render={({ field }) => (
                        <AsyncSelect
                          {...field}
                          styles={selectStyles}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={defaultAirportOptions}
                          placeholder="Select Origin Airport"
                          isDisabled={!manual}
                          value={
                            field.value
                              ? { label: field.value, value: field.value }
                              : null
                          }

                          onChange={(option) => {
                            field.onChange(option?.label || "");
                          }}
                        />
                      )}
                    />

                      {errors.actualFlights?.[index]?.actual_airport_of_origin && (
                      <p className="error-text">{errors.actualFlights?.[index]?.actual_airport_of_origin.message}</p>
                    )}

                  </div>




                  <div className="group-claim-input-wrapper">
                    <label >Arrival date & time <span style={{ color: "red" }}>*</span></label>




                    <div className="custom-date-time-container">


                      <div className="custom-date-time-box">

                        {/* DATE */}
                        <Controller
                          name={`actualFlights.${index}.actual_arrival_date`}
                          control={control}
                          rules={{
                            required: "Arrival Date is required",
                            validate: validateDateFormat,
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <CustomDOBPicker
                                {...field}
                                placeholder="Choose date"
                                inputRequired={true}

                                inputClassName="custom-date-input"
                                disabled={!manual}
                                error={fieldState.error?.message}
                              />
                            </>
                          )}
                        />

                        {/* TIME */}
                        <Controller
                          name={`actualFlights.${index}.actual_arrival_time`}
                          control={control}
                          rules={{
                            required: "Arrival Time is required",
                          }}
                          render={({ field, fieldState }) => (
                            <>
                              <input
                                {...field}
                                type="time"
                                className="custom-time-input"
                                disabled={!manual}
                              />
                            </>
                          )}
                        />
                      </div>


                    </div>


                    {/* ERROR */}
                    {(errors.actualFlights?.[index]?.actual_arrival_date ||
                      errors.actualFlights?.[index]?.actual_arrival_time) && (
                        <p className="error-text">
                          {errors.actualFlights?.[index]?.actual_arrival_date?.message ||
                            errors.actualFlights?.[index]?.actual_arrival_time?.message ||
                            "Arrival Date and Time is Required"}
                        </p>
                      )}


                  </div>


                  <div className="group-claim-input-wrapper">
                    <label >Airport of destination <span style={{ color: "red" }}>*</span></label>


                    <Controller
                      name={`actualFlights.${index}.actual_airport_of_destination`}
                      control={control}
                      rules={{ required: "Destination airport is required" }}
                      render={({ field }) => (
                        <AsyncSelect
                          {...field}
                          styles={selectStyles}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={defaultAirportOptions}
                          placeholder="Select Destination Airport"
                          isDisabled={!manual}


                          value={
                            field.value
                              ? { label: field.value, value: field.value }
                              : null
                          }

                          onChange={(option) => {
                            field.onChange(option?.label || "");
                          }}
                        />
                      )}
                    />

                      {errors.actualFlights?.[index]?.actual_airport_of_destination && (
                      <p className="error-text">{errors.actualFlights?.[index]?.actual_airport_of_destination.message}</p>
                    )}
                    

                  </div>


                  <div className="group-claim-input-wrapper">
                    <label className="input-label">Flight Class <span style={{ color: "red" }}>*</span></label>

                    <Controller
                      name={`actualFlights.${index}.actual_flight_class`}
                      control={control}
                      rules={{ required: "Please select Flight Class" }}
                      render={({ field }) => (


                        <Select
                          placeholder="Select Flight Class"
                          data={flightClassOptions}
                          rightSection={<SelectIcon />}
                          value={field.value}
                          onChange={(v) => field.onChange(v)}
                        />
                      )}
                    />

                    {errors.actualFlights?.[index]?.actual_flight_class && (
                      <p className="error-text">{errors.actualFlights?.[index]?.actual_flight_class.message}</p>
                    )}
                  </div>


                  <div className="group-claim-input-wrapper">
                    <label className="input-label">Flight info didn't appear ?</label>
                    <button className="btn btn-manual" type="button" onClick={() => {
                      setValue(`actualFlights.${index}.manual`, true);
                    }} >

                      enter manually

                    </button>

                  </div>


                </div>

                <div style={{marginTop:'30px'}}>

                  <div className="group-claim-input-wrapper">
                    <label className="input-label">How was this flight provided?<span style={{ color: "red" }}>*</span></label>
<div className="group-radio-btn-wrapper">
                  <Controller
                        name={`actualFlights.${index}.flight_provider`}
                      control={control}
                       rules={{ required: "Please select Flight Provider" }}
                        render={({ field }) => (
                          <>

                             <div className="group-claim-radio-btn" onClick={() => field.onChange("self_booked")}>

                              <input
                                type="radio"
                                value="self_booked"
                                name={field.name}
                                checked={field.value === "self_booked"}

                              />
                              <label>Booked this flight myself</label>

                            </div>
                            <div className="group-claim-radio-btn" onClick={() => field.onChange("provided_by_airline")}>
                              <input
                                type="radio"
                                value="provided_by_airline"
                                name={field.name}
                                checked={field.value === "provided_by_airline"}

                              />
                              <label>Airline rebooked me</label>


                            </div>

                           


                            

                          </>
                        )}
                      />
                      
                      </div>

                     {errors.actualFlights?.[index]?.flight_provider && (
                      <p className="error-text">{errors.actualFlights?.[index]?.flight_provider.message}</p>
                    )}
                    
                    </div>
                </div>

               
              </div>
            )
          })}


          <button className="btn btn-manual" type="button" onClick={() => addActualFlights({ search_by: 'airline_name', actual_flight_class:'Economy' })}>

            Add Actual flight

          </button>

        </div>
        }
       

           {/* ================= GROUP DETAILS ================= */}

        <div className="group-claim-section">

        <h2 className="group-claim-header">Personal Information</h2>

        <div className="group-claim-input-grid">

          <div className="group-claim-input-wrapper">
            <label >First name (as on ticket)<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.first_name"
              control={control}
              rules={{
                required: "Enter First Name",
              }}
              render={({ field }) => (
                <TextInput
                  hideControls
                  placeholder="Enter First Name"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.first_name && (
              <p className="error-text">{errors.personalInfo?.first_name?.message}</p>
            )}
            </div>
            

             <div className="group-claim-input-wrapper">
            <label >Last name (as on ticket)<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.last_name"
              control={control}
              rules={{
                required: "Enter Last Name",
              }}
              render={({ field }) => (
                <TextInput
                  hideControls
                  placeholder="Enter Last Name"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.last_name && (
              <p className="error-text">{errors.personalInfo?.last_name?.message}</p>
            )}
            </div>
            

              <div className="group-claim-input-wrapper">
            <label >Date of Birth<span style={{ color: "red" }}>*</span></label>
                      <div className="custom-date-time-box" style={{ position: 'relative' }}>

            <Controller
              name="personalInfo.date_of_birth"
              control={control}
              rules={{
                required: "Date of Birth is Required",
              }}
              render={({ field }) => (
                <CustomDOBPicker
                  inputRequired={true}
                                   value={field.value ?? ""}
                                   onChange={field.onChange}
                                   error={errors.date_of_birth?.message}
                                 />
              )}
                />
                
                </div>

            {errors.personalInfo?.date_of_birth && (
              <p className="error-text">{errors.personalInfo?.date_of_birth?.message}</p>
            )}
            </div>
            
              <div className="group-claim-input-wrapper">
            <label >Phone Number<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.contact_no"
              control={control}
              rules={{
                required: "Mobile Number is required",
                  validate: (value) => {
      if (!value) return "Mobile Number is required";

      const stringValue = String(value);

      if (!/^\d+$/.test(stringValue)) {
        return "Only digits are allowed";
      }

      if (stringValue.length !== 10) {
        return "Mobile Number must be exactly 10 digits";
      }

      return true;
    },
              }}
              render={({ field }) => (
                <NumberInput
                  hideControls
                  placeholder="Enter your phone number"
                  
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.contact_no && (
              <p className="error-text">{errors.personalInfo?.contact_no?.message}</p>
            )}
            </div>


             <div className="group-claim-input-wrapper">
            <label >Email<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.email_id"
              control={control}
              rules={{
                required: "Email Address is Required",
              }}
              render={({ field }) => (
                <TextInput
                  
                  hideControls
                  placeholder="Enter your email"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.email_id && (
              <p className="error-text">{errors.personalInfo?.email_id?.message}</p>
            )}
            </div>

              <div className="group-claim-input-wrapper">
            <label >Passport Number<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.passport_number"
              control={control}
              rules={{
                required: "Passport Number is Required",
              }}
              render={({ field }) => (
                <TextInput
                  
                  hideControls
                  placeholder="Enter Passport Number"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.passport_number && (
              <p className="error-text">{errors.personalInfo?.passport_number?.message}</p>
            )}
            </div>

             <div className="group-claim-input-wrapper">
            <label >Ticket Number<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.tickets"
              control={control}
              rules={{
                required: "Ticket Number is Required",
              }}
              render={({ field }) => (
                <NumberInput
                  
                  hideControls
                  placeholder="Enter Ticket Number"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.tickets && (
              <p className="error-text">{errors.personalInfo?.tickets?.message}</p>
            )}
            </div>

              <div className="group-claim-input-wrapper">
            <label >Airline Reservation Number<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.airline_res_no"
              control={control}
              rules={{
                required: "Airline Reservation Number is Required",
              }}
              render={({ field }) => (
                <TextInput
                  
                  hideControls
                  placeholder="Enter Airline Reservation Number"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.airline_res_no && (
              <p className="error-text">{errors.personalInfo?.airline_res_no?.message}</p>
            )}
            </div>

             <div className="group-claim-input-wrapper">
            <label >Street address<span style={{ color: "red" }}>*</span></label>

            {!manualAddress ? (
    <Controller
      name="personalInfo.address"
      control={control}
      defaultValue=""
      rules={{ required: "Home Address is Required" }}
      render={({ field }) => {
        const value = field.value
          ? { label: field.value, value: field.value }
          : null;

        return (
          <GooglePlacesAutocomplete
            apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
            selectProps={{
              value,
              placeholder: "Search address...",
              onChange: (val) => {
                const addr = val ? val.label : "";

                field.onChange(addr); // ✅ ONLY THIS

                // optional: autofill other fields
                onPlaceSelect_JS(val);
              },
              styles: selectStyles,
            }}
          />
        );
      }}
    />
  ) : (
    <Controller
      name="personalInfo.address"
      control={control}
      defaultValue=""
      rules={{ required: "Home Address is Required" }}
      render={({ field }) => (
        <input
          {...field}
          className="input-box"
          placeholder="Enter address"
          type="text"
        />
      )}
    />
  )}

  {errors.personalInfo?.address && (
    <p className="error-text">{errors.personalInfo?.address.message}</p>
  )}
            </div>


             <div className="group-claim-input-wrapper">
            <label >Unit</label>

            <Controller
              name="personalInfo.unit"
              control={control}
             
              render={({ field }) => (
                <TextInput
                  
                  hideControls
                  placeholder="Unit"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

           
            </div>

             <div className="group-claim-input-wrapper">
            <label >City<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.city"
              control={control}
              rules={{
                required: "City is Required",
              }}
              render={({ field }) => (
                <TextInput
                  readOnly={!manualAddress}
                  hideControls
                  placeholder="Enter City"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.city && (
              <p className="error-text">{errors.personalInfo?.city?.message}</p>
            )}
            </div>

              <div className="group-claim-input-wrapper">
            <label >State/Region<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.state"
              control={control}
              rules={{
                required: "State/Region is Required",
              }}
              render={({ field }) => (
                <TextInput
                  readOnly={!manualAddress}
                  hideControls
                  placeholder="Enter State/Region"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.state && (
              <p className="error-text">{errors.personalInfo?.state?.message}</p>
            )}
            </div>

             <div className="group-claim-input-wrapper">
            <label >ZIP/Postal code<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.postal_code"
              control={control}
              rules={{
                required: "ZIP/Postal code is Required",
              }}
              render={({ field }) => (
                <TextInput
                  readOnly={!manualAddress}
                  hideControls
                  placeholder="Enter ZIP/Postal code"
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.postal_code && (
              <p className="error-text">{errors.personalInfo?.postal_code?.message}</p>
            )}
            </div>

             <div className="group-claim-input-wrapper">
            <label >Country<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.country"
              control={control}
              rules={{
                required: "Country is Required",
              }}
              render={({ field }) => (
                <div
          className="select-box"
          style={{
            borderColor: "#E6F6FF",
            backgroundColor: "#e8eef7",
          }}
        >
          <CountryDropdown
            className="countrydropdown2 form-control underline-input"
            id="tcountry"
            disabled={!manualAddress} // ✅ RHF controlled
            defaultOptionLabel="- Select country -"
            value={field.value} // ✅ RHF value
            onChange={(val) => field.onChange(val)} // ✅ RHF update
            style={{
              background: "none",
              outline: "none",
              border: "none",
              boxShadow: "none",
            }}
          />

          <VectorIcon />
        </div>
              )}
            />

            {errors.personalInfo?.country && (
              <p className="error-text">{errors.personalInfo?.country?.message}</p>
            )}
            </div>

             <div className="group-claim-input-wrapper">
                    <label className="input-label">Can’t find your address?</label>
                    <button className="btn btn-manual" type="button" onClick={() => {
                      setValue(`personalInfo.manual_address`, true);
                    }} >

                      enter manually

              </button>

              
              
            </div>

              <div className="group-claim-input-wrapper">
                    <label className="input-label">Boarding Pass</label>
                   

                      <Controller
                                 name="personalInfo.boarding_pass"
                                 control={control}
                                 // rules={{ required: "Please attach a document" }}
                                 render={({ field }) => (
                                   <div>
                                     <input
                                             type="file"
                                             id="boarding_pass"
                                             accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                                             onChange={(e) => field.onChange(e.target.files)}
                                             style={{display:"none"}}
                                         />
                                         
                                          
                                                           
                                                             <div
                                                               onClick={() =>
                                                                 document.getElementById(`boarding_pass`).click()
                                                               }
                                             className="input-box"
                                             
                                                               style={{
                                                                 color: field?.value?.[0]?.name
                                                                   ? "#222222"
                                                                       : "#7b8287",
                                                                   marginTop:0
                                                               }}
                                                             >
                                                              {field?.value?.[0]?.name ?? "Upload File"}
                                                               <UploadIcon />
                                                             </div>
                                                            
                                                           </div>
                                   
                                 )}
              />
              

            </div>
            

             <div className="group-claim-input-wrapper">
                    <label className="input-label">Passport <span style={{ color: "red" }}>*</span></label>
                   

                      <Controller
                                 name="personalInfo.passport"
                                 control={control}
                                 rules={{ required: "Passport is required" }}
                                 render={({ field }) => (
                                   <div>
                                     <input
                                             type="file"
                                             id="passport"
                                             accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                                             onChange={(e) => field.onChange(e.target.files)}
                                             style={{display:"none"}}
                                         />
                                         
                                          
                                                           
                                                             <div
                                                               onClick={() =>
                                                                 document.getElementById(`passport`).click()
                                                               }
                                             className="input-box"
                                             
                                                               style={{
                                                                 color: field?.value?.[0]?.name
                                                                   ? "#222222"
                                                                       : "#7b8287",
                                                                   marginTop:0
                                                               }}
                                                             >
                                                              {field?.value?.[0]?.name ?? "Upload File"}
                                                               <UploadIcon />
                                                             </div>
                                                            
                                                           </div>
                                   
                                 )}
              />

                {errors.personalInfo?.passport && (
              <p className="error-text">{errors.personalInfo?.passport?.message}</p>
            )}
              

            </div>
            
            {

              (watch('groupDetails.type_of_claim') === "lost/damaged" )&& <>
              
                  <div className="group-claim-input-wrapper">
            <label >Luggage Delivery Date<span style={{ color: "red" }}>*</span></label>
                      <div className="custom-date-time-box" style={{ position: 'relative' }}>

            <Controller
              name="personalInfo.luggage_delivered"
              control={control}
              rules={{
                required: "Luggage Delivered Date is Required",
              }}
              render={({ field }) => (
                <CustomDOBPicker
                  inputRequired={true}
                                   value={field.value ?? ""}
                                   onChange={field.onChange}
                                   error={errors.luggage_delivered?.message}
                                 />
              )}
                />
                
                </div>

            {errors.personalInfo?.luggage_delivered && (
              <p className="error-text">{errors.personalInfo?.luggage_delivered?.message}</p>
            )}
                </div>
                
                </>
              
          }
            
            {
              (watch('groupDetails.type_of_claim') === "lost/damaged" || watch('groupDetails.type_of_claim') === "lost_wages") && <>

            
              <div className="group-claim-input-wrapper">
            <label >Estimated amount of the claim<span style={{ color: "red" }}>*</span></label>

            <Controller
              name="personalInfo.claim_amount"
              control={control}
              rules={{
                required: "Estimated Amount is Required",
              }}
              render={({ field }) => (
                <NumberInput
                  hideControls
                  placeholder="Enter amount of claim "
                  value={field.value}
                  onChange={(v) => field.onChange(v)}
                />
              )}
            />

            {errors.personalInfo?.claim_amount && (
              <p className="error-text">{errors.personalInfo?.claim_amount?.message}</p>
            )}
            </div>
              
              </>
              
}
           
            
            
         
          </div>
          
           <div className="group-claim-input-wrapper" style={{marginTop:'30px'}}>
                    <label >Note</label>
                  <Controller
                                        name={`personalInfo.note`}
                                        control={control}
                                        render={({ field }) => (
                                          <textarea
                                            {...field}
                                            className="group-claim-textarea"
                                            rows={5}
                                           
                                           
                                          />
                                        )}
                    />
                    
                    </div>

        </div>

        

        <div className="group-claim-section">
          {
            travelers?.length > 0 &&   <div style={{height:'80px',background:'#a3c3ed38',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'18px',fontWeight:'500',marginTop:"40px",marginBottom:"40px",borderRadius:'20px'}}>
                      
                      {`${travelers?.length} ${travelers?.length > 1?"Travelers":"Traveler"} added `}
                     
                    </div>
}
        

          <div style={{display:'flex',justifyContent:"center"}}>
            <button type="button" onClick={()=>travelersModalOpen()} className="group-claim-fill-btn" >{travelers?.length > 0?"Edit":"Import"} Travelers</button>
          </div>

        </div>



         <div className="group-claim-section">

          <h2 className="group-claim-header">Upload Documents</h2>

          <div className="group-claim-input-grid">

             <div className="group-claim-input-wrapper">
                    <label className="input-label">Additional Documents</label>
                   

                      <Controller
                                 name="additional_files"
                                 control={control}
                                 // rules={{ required: "Please attach a document" }}
                                 render={({ field }) => (
                                   <div>
                                     <input
                                             type="file"
                                             id="additional_files"
                                             accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                                             onChange={(e) => field.onChange(e.target.files)}
                                       style={{ display: "none" }}
                                       multiple
                                         />
                                         
                                          
                                                           
                                                             <div
                                                               onClick={() =>
                                                                 document.getElementById(`additional_files`).click()
                                                               }
                                             className="input-box"
                                             
                                                               style={{
                                                                 color: field?.value?.[0]?.name
                                                                   ? "#222222"
                                                                       : "#7b8287",
                                                                   marginTop:0
                                                               }}
                                                             >
                                                              {field?.value?.length > 0? `${field?.value?.length} Files` : "Upload Files"}
                                                               <UploadIcon />
                                                             </div>
                                                            
                                                           </div>
                                   
                                 )}
              />
              

            </div>


            {
              (watch('groupDetails.type_of_claim') === "lost/damaged" || watch('groupDetails.type_of_claim') === "lost_wages") &&  <div className="group-claim-input-wrapper">
                    <label className="input-label">Luggage claim receipt <span style={{ color: "red" }}>*</span></label>
                   

                      <Controller
                                 name="luggage_file"
                                 control={control}
                                 rules={{ required: "Please attach Luggage claim receipt" }}
                                 render={({ field }) => (
                                   <div>
                                     <input
                                             type="file"
                                             id="luggage_file"
                                             accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                                             onChange={(e) => field.onChange(e.target.files)}
                                       style={{ display: "none" }}
                                       
                                         />
                                         
                                          
                                                           
                                                             <div
                                                               onClick={() =>
                                                                 document.getElementById(`luggage_file`).click()
                                                               }
                                             className="input-box"
                                             
                                                               style={{
                                                                 color: field?.value?.[0]?.name
                                                                   ? "#222222"
                                                                       : "#7b8287",
                                                                   marginTop:0
                                                               }}
                                                             >
                                                              {field?.value?.[0]?.name ?? "Upload File"}
                                                               <UploadIcon />
                                                             </div>
                                                            
                                                           </div>
                                   
                  )}
                  

                  

                />
                
                  {errors.luggage_file && (
              <p className="error-text">{errors.luggage_file?.message}</p>
            )}
              

            </div>
            }
             
            </div>
          
          </div>




        <div className="group-agreement-wrapper">
          
          <div style={{display:"flex",flexDirection:'column',gap:'10px'}}>

            
              <Controller
  name="termsAccepted"
  control={control}
  defaultValue={false}
  
  render={({ field }) => (
    <div className="attorney-notes-checkbox-input-container">
      <input
        type="checkbox"
        className="form-check-input attorney-notes-checkbox-input"
        id="termsCheckbox"
        checked={field.value}
        onChange={(e) => {
          if (handleCheckTerm()) {
            field.onChange(e.target.checked);
          }
        }}
      />

      <label
        className="form-check-label mt-2"
        htmlFor="termsCheckbox"
        style={{ marginLeft: "12px" }}
      >
        I agree to the{" "}
        <a
          href="https://api.linsoatours.com/Images/other_document/FLT_Airline_claims_-_TC_1.pdf"
          target="_blank"
          onClick={() => {
           
            
            setValue("isTermsLinkClicked", true)
          }} // ✅ RHF state
        >
          Terms and Conditions
        </a>
      </label>
    </div>
  )}
          />
          

          <div className="attorney-notes-checkbox-input-container mobile-attorney">
                            <input
                              type="checkbox"
                              className="form-check-input  attorney-notes-checkbox-input"
                              id="agreementCheckbox"
                              checked={isAgreementChecked}
                              onChange={(e) => {
                                if (handleCheckAgreement()) {
                                  handleAgreementChange(e);
                                }
                              }}
                            />
                            <label
                              className="form-check-label mt-2"
                              htmlFor="agreementCheckbox"
                              style={{ marginLeft: "12px" }}
                            >
                              I agree to the{" "}
                              <Link
                onClick={async() => {
                  
                    const isValid = await trigger(); // ✅ validate entire form

                    if (!isValid) {
                    scrollToError()
      return
                  }
                  

                                  if (handleCheckAgreement()) {
                                    setShowContinueBtn(false)
                                    setAgreementModalOpen(true);
                                  }
                                }}
                              >
                                Agreement
                              </Link>
                            </label>
                            {signatureCaptured && (
                              <button
                                type="button"
                                onClick={() => {
                                  if (pdfBlob) {
                                    const url = URL.createObjectURL(pdfBlob);
                                    window.open(url, "_blank");
                                  }
                                }}
                                className="view-btn"
                              >
                                <span>
                                  <svg
                                    width="18px"
                                    height="18px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g
                                      id="SVGRepo_tracerCarrier"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                      {" "}
                                      <path
                                        d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z"
                                        stroke="#fff"
                                        stroke-width="1.5"
                                      ></path>{" "}
                                      <path
                                        d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                                        stroke="#fff"
                                        stroke-width="1.5"
                                      ></path>{" "}
                                    </g>
                                  </svg>
                                </span>
                                View Agreement
                              </button>
                            )}
          </div>
          



           {travelers.length > 0 && (
                            <div className="attorney-notes-checkbox-input-container mobile-attorney" style={{ flexWrap: "wrap", gap: "12px" }}>
                              <input
                                type="checkbox"
                                className="form-check-input attorney-notes-checkbox-input"
                                id="powerOfAttorneyCheckbox"
                                checked={isPowerOfAttorneyChecked}
                                onChange={(e) => {
                                  if (handleCheckPowerOfAttorney()) {
                                    handlePowerOfAttorneyChange(e);
                                  }
                                }}
                              />
                              <label
                                className="form-check-label mt-2"
                                htmlFor="powerOfAttorneyCheckbox"
                              // style={{ marginLeft: "12px" }}
                              >
                                I agree to the{" "}
                                <Link
                  onClick={async() => {
                    
                    const isValid = await trigger(); // ✅ validate entire form

                      if (!isValid) {
                    scrollToError()
      return
                  }
                                    if (handleCheckPowerOfAttorney()) {
                                      openPowerOfAttorneyModal();
                                    }
                                  }}
                                >
                                  Power of Attorney
                                </Link>
                              </label>
                              {poaPdf !== null && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (poaPdf) {
                                      const url = URL.createObjectURL(poaPdf);
                                      window.open(url, "_blank");
                                    }
                                  }}
                                  className="view-btn"
                                >
                                  <span>
                                    <svg
                                      width="18px"
                                      height="18px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <path
                                          d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z"
                                          stroke="#fff"
                                          stroke-width="1.5"
                                        ></path>{" "}
                                        <path
                                          d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                                          stroke="#fff"
                                          stroke-width="1.5"
                                        ></path>{" "}
                                      </g>
                                    </svg>
                                  </span>
                                  View POA
                                </button>
                              )}
          
          
                           
                            </div>
          
          
          )}
          </div>

            <button type="submit" className="group-claim-fill-btn" disabled={!isAgreementChecked ||
  !watch('termsAccepted') ||
  (travelers?.length > 0 && !isPowerOfAttorneyChecked)}>Submit</button>
     
          

        </div>



        





      </form>

      

       <Modal  opened={successModalOpened}
        closeOnClickOutside={false}
        withCloseButton={false}
        size={'lg'}


        radius={'lg'}
        padding={'lg'}
        onClose={successModalClose}
      
      >

 <div className="stepper-container group-claim" style={{padding:'20px'}}>
      {isSuccessResponse ? (
        <div>
          <SuccessIcon />

          <div >
            <h4 className="result-header-text" style={{ color: "#314064" }}>
              Congratulations!
            </h4>
            <h6 className="result-sub-text">
              Your claim has been successfully submitted! Our team will review
              your case, and we will update you as soon as we have news.
            </h6>
            <h6 className="result-sub-text">
              You will also receive an email notification when there is an
              update to the status of your claim.
            </h6>
            <h6 className="result-sub-text">
              You can always check the status and progress of your claim by
              logging in to your account.
            </h6>
            <h6 className="result-sub-text">
              Your Claim ID is: <strong>{getValues('personalInfo.contact_no')}</strong>. Please save it
              for future reference.
                </h6>
                
                <div style={{display:'flex',justifyContent:'center',marginTop:'20px'}}>
                <CustomButton btnText={'Check Claim'} onClick={()=>navigate("/claimstatus")}/>
                  </div>
          </div>
        </div>
      ) : (
        <div className="result-wrapper">
          <FailedIcon />

          <div style={{ marginTop: "30px" }}>
            <h4 className="result-header-text" style={{ color: "#D04244" }}>
              Submission failed
            </h4>
            <h6 className="result-sub-text">
              Unfortunately, we were unable to process your claim submission.
              Please check your internet connection and try again.
            </h6>
            <div className="support-wrapper">
              <div className="customer-support-wrapper sub-text">
                <span onClick={() => navigate("/contact-us")}>
                  <HeadSetIcon />
                  Contact our support team
                </span>
              </div>

              <div className="customer-support-wrapper sub-text">
                <span onClick={() => navigate("/disclaimer")}>
                  <DocumentIcon />
                  Read more about your rights
                </span>
              </div>
                  </div>
                  <div style={{display:'flex',justifyContent:'center',marginTop:'20px'}}>
                <CustomButton btnText={'Close'} onClick={()=>successModalClose()}/>
                  </div>
          </div>
        </div>
      )}
    </div>

      </Modal>
      <Modal  opened={travelersModalOpened}
        closeOnClickOutside={false}
        withCloseButton={true}
        fullScreen={true}
        onClose={travelersModalClose}
      
      >

        <TravelerForm travelers={travelers} setTravelers={setTravelers} travelersModalClose={travelersModalClose} />
        

      </Modal>
      
       <Modal
              opened={multiFlightOpened}
              closeOnClickOutside={false}
              onClose={() => {
                setSelectedFlightIndex(null);
                setMultiFlightData(prev =>
                  prev.map((f) => ({
                    ...f,
                    selected: false  // reset all
                  }))
                );
      
      
                multiFlightClose();
              }}
              centered
              fullScreen={isMobile}
              size={"1000px"}
              withCloseButton={true}
      
            >
      
              <div style={{ padding: isMobile ? "0px 0px 20px 0px" : "20px" }}>
      
                <h2 style={{ fontSize: "20px", fontWeight: 'bold' }}>
                  Select Your Flight Details
                </h2>
      
                {
                  multiFlightData?.map((flight, index) => {
      
      
                    const operationalTimes = flight?.operationalTimes || {};
                    const status = flight?.status || "";
      
                    return (<article className="flight-card" key={index} style={{ cursor: "pointer", position: "relative", background: flight?.selected ? "#0084ff05" : "#fff", border: flight?.selected ? "1px solid #457ffdff" : "1px solid #e5e7eb" }} onClick={() => {
                      handleSelectFlight(index)
                    }}>
      
      
                      <span className="status-chip" style={{ position: "absolute", top: "16px", left: "50%", transform: "translateX(-50%)" }}>
                        <span className="status-dot" />
                        {getFlightStatus(status)}
      
                      </span>
      
                      <span className="select-flight-radio">
                        <input
                          type="radio"
      
                          name="selectedFlight"
                          checked={flight?.selected || false}
                          readOnly
                          style={{
                            transform: "scale(1.5)",     // size
                            accentColor: flight?.selected ? "#457ffdff" : "gray"  // color
                          }}
                        />
                      </span>
      
      
                      {/* <header className="flight-header-new">
              {
                flight?.airline?.iata &&  <div className="airline-badge">{flight?.airline?.iata}</div>
             }
              <div className="title">
                <h1>
                  {flight?.airline?.name} • {flight?.flight?.number}
                </h1>
               
              </div>
      
            
              
            
            </header> */}
      
                      <section className="content">
                        <div className="route" style={{ position: "relative" }}>
                          <div className="ap">
                            {flight?.departure?.iata && <div className="code">{flight?.departure?.iata}</div>}
                            <div className="city">
                              {flight?.departure?.airport}
                            </div>
                            {/* <div className="meta">
                            {flight?.departure?.terminal && <span>Terminal {flight?.departure?.terminal}</span>}  
                            {flight?.departure?.gate && <span>Gate {flight?.departure?.gate}</span>} 
                  </div>
                  <div className="meta">
                     {flight?.departure?.timezone && <span>Timezone: {flight?.departure?.timezone}</span>} 
                  
                  </div> */}
                          </div>
      
                          <div className="plane">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                              <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" />
                            </svg>
                          </div>
      
                          <div className="ap" style={{ textAlign: "right" }}>
                            <div className="code">{flight?.arrival?.iata}</div>
                            <div className="city">
                              {flight?.arrival?.airport}
                            </div>
                            {/* <div className="meta" style={{ justifyContent: "flex-end" }}>
                            {flight?.arrival?.terminal && <span>Terminal {flight?.arrival?.terminal}</span>} 
                             {flight?.arrival?.gate && <span>Gate {flight?.arrival?.gate}</span>}
                  </div>
      
                    <div className="meta" style={{ justifyContent: "flex-end" }}>
                     {flight?.arrival?.timezone && <span>Timezone: {flight?.arrival?.timezone}</span>} 
                  
                  </div> */}
                          </div>
                        </div>
      
      
      
      
      
                        <div className="new-flight-timing-wrapper">
                          <div style={{ border: "1px solid #ddd" }}>
                            <h5 className="new-flight-timing-title">
                              <IconPlaneDeparture size={'20px'} /> Departure
                            </h5>
                            <div className="new-flight-timing-grid">
                              <div className="new-flight-timing">
                                <span className="new-flight-timing-label">Scheduled Departure</span>
                                <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal)}</span>
                                {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                              </div>
      
                              {
                                (status !== "C" && status !== "DN" && status !== "S" && status !== "Scheduled") && <div className="new-flight-timing">
                                  <span className="new-flight-timing-label">Gate Departure</span>
                                  <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                                  {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                                </div>
                              }
      
                              {
                                (status === "C" || status === "DN" || status === "S" || status === "Scheduled") && <div className="new-flight-timing">
                                  <span className="new-flight-timing-label">Estimated Departure</span>
                                  <span className="new-flight-timing-date">{fmt(operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                                  {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                                </div>
                              }
      
                              {
                                (status === "A" || status === "L" || status === "D" || status === "R") && <div className="new-flight-timing">
                                  <span className="new-flight-timing-label">Takeoff</span>
                                  <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayDeparture?.dateLocal || operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledRunwayDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                                  {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                                </div>
                              }
      
                            </div>
      
                          </div>
      
                          <div style={{ border: "1px solid #ddd" }}>
                            <h5 className="new-flight-timing-title">
                              <IconPlaneArrival size={'20px'} /> Arrival
                            </h5>
                            <div className="new-flight-timing-grid">
                              <div className="new-flight-timing">
                                <span className="new-flight-timing-label">Scheduled Arrival</span>
                                <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal)}</span>
                                {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
      
                              </div>
      
                              {
                                (status === 'S' || status === "U" || status === "A" || status === "D" || status === "C" || status === "R" || status === "Scheduled") && <div className="new-flight-timing">
                                  <span className="new-flight-timing-label">Estimated Arrival</span>
                                  <span className="new-flight-timing-date">{fmt(operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
                                  {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span> */}
      
                                </div>
                              }
      
                              {
                                (status === "L") && <div className="new-flight-timing">
                                  <span className="new-flight-timing-label">Landing</span>
                                  <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayArrival?.dateLocal || operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
                                  {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span> */}
      
                                </div>
                              }
      
      
                              {
                                (status === "L" || status === "D") && <div className="new-flight-timing">
                                  <span className="new-flight-timing-label">Gate Arrival</span>
                                  <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
                                  {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal )}</span> */}
                                </div>
                              }
      
                            </div>
      
                          </div>
                        </div>
                      </section>
      
      
      
                    </article>)
      
      
      
                  })
                }
      
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "15px" }}>
                  <CustomButton btnText={'Apply'} onClick={()=>handleSaveFlightDetails()} style={{ width: "200px" }} disabled={selectedFlightIndex === null} />
                </div>
      
              </div>
      
      </Modal>
      

       <AgreementModal
                      isOpen={isAgreementModalOpen}
                      onRequestClose={closeAgreementModal}
                      onSignatureAdded={handleSignatureAdded}
                      onPdfGenerated={handlePdfGenerated}
                      setEnvelopeId={setEnvelopeId}
                      setAgreementUrl={setAgreementUrl}
                      envolpeId={envolpeId}
                      signUrl={signUrl}
                      setSignUrl={setSignUrl}
                      setIsDocusignModalOpen={setIsDocusignModalOpen}
                      setIsFetching={setIsFetching}
                      setDocumentFetched={setDocumentFetched}
                      agreementDetails={dataToStore}
        activeTab={activeTab}
         type_of_claim={getValues('groupDetails.type_of_claim')}
      />
      

       <DocuSignModal
                      isOpen={isDocuSignModalOpen}
                      onRequestClose={() => { setIsDocusignModalOpen(false); }}
                      signUrl={signUrl}
                      setSignUrl={setSignUrl}
                      handleIframeClose={handleIframeClose}
      />
      

       {dataToStore && (
              <PowerContent ref={powerRef} agreementDetails={dataToStore} />
            )}
    </div>
  );
}